import url from 'postcss-url'
import { wexinShare } from '@/assets/js/weixin-jssdk.js'
import mqq from 'qq-js-sdk'

let base = {}
var u = navigator.userAgent
base.install = function (Vue, options) {
  //右键办理验收所需参数
  var acceptanceUrl = window.location.href, // 当前页面路径，需替换
    previewUrl = window.location.href // 当前页面路径，需替换
  //悬浮购物车
  Vue.prototype.changeData = function (data) {
    //changeData是函数名
    $('.el-cascader-panel .el-scrollbar.new').remove()
    var _this = this
    var _url = ''
    //types为hover悬浮显示
    if (data.types && data.types == 'hover') {
      var html = $('.el-cascader-panel .el-scrollbar:eq(1)').clone(true)
      var type = window.$changeFlowBlock
      if (type == 'flow') {
        type = 'flow-floorStyle'
      } else {
        type = 'block-floorStyle'
      }
      if (data.targetType == 'none') {
        return false
      }
      if (data.redirectUrl) {
        _url = _this.replaceDataByWell(data.redirectUrl, data, type)
      }
      if (!$('.el-cascader-panel .el-scrollbar.new').length) {
        var newHtml = ''
        $(html).addClass('new')
        // $(html).css({ 'width': '580px', 'height': '215px', 'min-width': '580px', 'min-height': '215px', 'max-width': '1000px' });
        $(html).css({ width: '999px', height: '215px', 'min-width': '999px', 'min-height': '215px', 'max-width': '1000px' })
        newHtml = '<iframe src=' + _url + ' width="100%" height="100%"></iframe>'
        $(html).html('').append(newHtml)
        $('.el-cascader-panel').append(html)
      } else {
        $('.el-cascader-panel .el-scrollbar.new iframe').attr('src', _url)
      }
      $('.el-cascader-panel .el-scrollbar.new').resizable({
        // helper: "widget_resizable_helper",
        start: function (event, ui) {
          $('iframe').each(function () {
            $("<div class='ui-resizable-iframeFix' style='background: #fff;'></div>")
              .css({
                width: this.offsetWidth + 'px',
                height: this.offsetHeight + 'px',
                position: 'absolute',
                opacity: '0.001',
                zIndex: 1000
              })
              .css($(this).offset())
              .appendTo('body')
          })
        },
        stop: function () {
          $('div.ui-resizable-iframeFix').each(function () {
            this.parentNode.removeChild(this)
          })
        }
      })
      if (window.innerWidth - this.rMenuPos.left - $('.right-menu').width() < 0) {
        setTimeout(() => {
          $('.right-menu .el-cascader-menu.el-scrollbar:last').css({ position: 'absolute', backgroundColor: 'white', right: '129px', border: 'solid 1px #e4e7ed' })
        }, 10)
      }
    } else if (data.menuName == '购物车') {
      var newHtml = ''
      //悬浮显示我的购物车
      if (!$('.el-cascader-panel .el-scrollbar.new').length) {
        _this.$http
          .get('/oqmid-pay-tool-web/shop/cart/toApp-list', {
            userId: _this.$store.state.userInfo.userId ? _this.$store.state.userInfo.userId : '',
            codes: _this.$store.state.userInfo.userId ? '' : _this.getQuery('localUserId') ? _this.getQuery('localUserId') : localStorage.getItem('wxud'),
            pfId: this.getQuery('prevPfId') ? this.getQuery('prevPfId') : window.$pfId
          })
          .then((res) => {
            if (res.state == 1) {
              if (res.data.cartList.length) {
                newHtml += '<li class="shopcart"><div class="cartContent"><i class="checkboxs" onclick="shopCartCheckAll(this)"></i><span>全选</span></div></li>'
                res.data.cartList.forEach((ele) => {
                  newHtml +=
                    '<li class="shopcart"><div class="cartContent" data-cart="' +
                    ele.cart_id +
                    '"><i class="checkboxs" onclick="shopCartCheck(this)"></i><span class="text" onclick="text()">' +
                    ele.product_name +
                    '</span><span class="num"><a href="javascript:;" class="reduce" onclick="reduce(this)">-</a><input type="text" readonly="readonly" value=' +
                    ele.buy_number +
                    ' name="one"/><a href="javascript:;" data-cart="' +
                    ele.cart_id +
                    '" class="add" onclick="add(this)">+</a></span></div></li>'
                })
                $('.el-cascader-panel').append(
                  '<div class="el-scrollbar el-cascader-menu new" style="width:210px !important;max-width:210px;" role="menu" id="cascader-menu-9806-1"><div class="el-cascader-menu__wrap el-scrollbar__wrap" style="margin-bottom: -17px; margin-right: -17px;"><ul class="el-scrollbar__view el-cascader-menu__list" style="margin-bottom:28px;">' +
                    newHtml +
                    '</ul></div><div class="acount"><span onclick="acount()">去结算 <i class="el-icon-arrow-right el-cascader-node__postfix tubiao"></i></span></div></div>'
                )
              } else {
                //显示购物车为空
                newHtml =
                  '<li role="menuitem" id="cascader-menu-3485-1-0" tabindex="-1" class="el-cascader-node in-active-path" aria-haspopup="true" aria-owns="cascader-menu-3485-1" aria-expanded="true"><span class="el-cascader-node__label"><a data-v-f5f5fd42="" class="zciid-jfwk001000000000000guru1627118658475950344"><span data-v-f5f5fd42=""></span> <span data-v-f5f5fd42="">购物车为空</span></a></span><i style="margin-right: 10px"></i></li>'
                $('.el-cascader-panel').append(
                  '<div class="el-scrollbar el-cascader-menu new" style="position:relative" role="menu" id="cascader-menu-9806-1"><div class="el-cascader-menu__wrap el-scrollbar__wrap" style="margin-bottom: -17px; margin-right: -17px;"><ul class="el-scrollbar__view el-cascader-menu__list">' +
                    newHtml +
                    '</ul></div></div>'
                )
              }
              if (window.innerWidth - this.rMenuPos.left - $('.right-menu').width() < 0) {
                setTimeout(() => {
                  $('.right-menu .el-cascader-menu.el-scrollbar:last').css({ position: 'absolute', backgroundColor: 'white', right: '129px', border: 'solid 1px #e4e7ed' })
                }, 10)
              }
            }
          })
      }
    } else if (data.targetType == 'search') {
      if (!$('.el-cascader-panel .el-scrollbar.new').length) {
        var html = $('.el-cascader-panel .el-scrollbar:eq(1)').clone(true)
        var newHtml = ''
        $(html).addClass('new')
        $(html).css('cssText', 'width:210px !important;max-width:210px;')
        newHtml = '<div class="search-box"><input type="text" placeholder="请输入"><button onclick="search(this)">搜索</button></div>'
        $(html).html('').append(newHtml)
        $('.el-cascader-panel').append(html)
      }
    } else {
      $('.el-cascader-panel .el-scrollbar.new').remove()
    }
  }
  //选择加入购物车
  Vue.prototype.chooseToCart = function (assetsPrice, assetsUnit, periodicPrice, periodicUnit, cart, cid, shopping, timesPrice, timesUnit) {
    var assid = this.getQuery('assetId')
    var newHtml =
      '<li class="shopchooseCart"><div class="cartContent" onclick="choosePrice(this,event)"><i class="checkboxs first curr" dataPrice=' +
      assetsPrice +
      ' dataUnit=' +
      assetsUnit +
      '></i><ul><li><span>资产交易价:</span><span>￥' +
      assetsPrice +
      '</span></li><li><span>资产单位:</span><span>' +
      assetsUnit +
      '</span></li></ul></div></li>'

    newHtml +=
      '<li class="shopchooseCart"><div class="cartContent" onclick="choosePrice(this,event)"><i class="checkboxs" dataPrice=' +
      periodicPrice +
      ' dataUnit=' +
      periodicUnit +
      '></i><ul><li><span>定期租赁价:</span><span>￥' +
      periodicPrice +
      '</span></li><li><span>资产单位:</span><span>' +
      periodicUnit +
      '</span></li></ul></div></li>'

    if (timesPrice) {
      newHtml +=
        '<li class="shopchooseCart"><div class="cartContent" onclick="choosePrice(this,event)"><i class="checkboxs" dataPrice=' +
        timesPrice +
        ' dataUnit=' +
        timesUnit +
        '></i><ul><li><span>次数租赁价:</span><span>￥' +
        timesPrice +
        '</span></li><li><span>资产单位:</span><span>' +
        timesUnit +
        '</span></li></ul></div></li>'
    }

    if (!$('.el-cascader-panel .el-scrollbar.new').length) {
      $('.el-cascader-panel').append(
        '<div class="el-scrollbar el-cascader-menu new" style="width:210px !important;max-width:210px;" role="menu" id="cascader-menu-9806-1"><div class="el-cascader-menu__wrap el-scrollbar__wrap" style="margin-bottom: -17px; margin-right: -17px;"><ul class="el-scrollbar__view el-cascader-menu__list" style="margin-bottom:28px;">' +
          newHtml +
          '</ul></div><div class="acount"><span onclick="addToCart(event,' +
          cart +
          ')">确定 <i class="el-icon-arrow-right el-cascader-node__postfix tubiao"></i></span></div></div>'
      )
    }
    //详情页
    if ($('.shoppingCart-r').length && !$('.right-menu').length) {
      if (!$('.shopping.el-cascader-menu').length) {
        $('.shoppingCart-r').append(
          '<div onclick="event.stopPropagation();" class="shopping el-cascader-menu new" role="menu" id="cascader-menu-9806-1"><div class="triangle"></div><div class="el-cascader-menu__wrap el-scrollbar__wrap"><ul class="el-scrollbar__view el-cascader-menu__list" style="margin-bottom:28px;">' +
            newHtml +
            '</ul></div><div class="acount"><span onclick="addToCart(event,' +
            cart +
            ')">确定 <i class="el-icon-arrow-right el-cascader-node__postfix tubiao"></i></span></div></div>'
        )
      } else {
        $('.shopping.el-cascader-menu').remove()
      }
    }
    //刷一刷
    if ($('.clickFab.showChoose').length && !$('.right-menu').length) {
      if (shopping) {
        //点击购买
        if (!$('.shopping .shopping.el-cascader-menu').length) {
          if ($('.cart .shopping.el-cascader-menu').length) {
            $('.shopping.el-cascader-menu').remove()
          }
          $('.clickFab.showChoose[cid=' + cid + ']:eq(' + (shopping ? 1 : 0) + ')').append(
            '<div onclick="event.stopPropagation();" class="shopping el-cascader-menu new" role="menu" id="cascader-menu-9806-1"><div class="triangle"></div><div class="el-cascader-menu__wrap el-scrollbar__wrap"><ul class="el-scrollbar__view el-cascader-menu__list" style="margin-bottom:28px;">' +
              newHtml +
              '</ul></div><div class="acount"><span onclick="addToCart(event,' +
              cart +
              ',' +
              (shopping ? 1 : '') +
              ')">确定 <i class="el-icon-arrow-right el-cascader-node__postfix tubiao"></i></span></div></div>'
          )
        } else {
          $('.shopping.el-cascader-menu').remove()
        }
      } else {
        //点击购物车
        if (!$('.cart .shopping.el-cascader-menu').length) {
          if ($('.shopping .shopping.el-cascader-menu').length) {
            $('.shopping.el-cascader-menu').remove()
          }
          $('.clickFab.showChoose[cid=' + cid + ']:eq(' + (shopping ? 1 : 0) + ')').append(
            '<div onclick="event.stopPropagation();" class="shopping el-cascader-menu new" role="menu" id="cascader-menu-9806-1"><div class="triangle"></div><div class="el-cascader-menu__wrap el-scrollbar__wrap"><ul class="el-scrollbar__view el-cascader-menu__list" style="margin-bottom:28px;">' +
              newHtml +
              '</ul></div><div class="acount"><span onclick="addToCart(event,' +
              cart +
              ',' +
              (shopping ? 1 : '') +
              ')">确定 <i class="el-icon-arrow-right el-cascader-node__postfix tubiao"></i></span></div></div>'
          )
        } else {
          $('.shopping.el-cascader-menu').remove()
        }
      }
    }
  }

  //寻找页面链接参数
  Vue.prototype.getQuery = function (name) {
    // 正则：[找寻'&' + 'url参数名字' = '值' + '&']（'&'可以不存在）
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    let r = window.location.search.substr(1).match(reg) //substr() 的参数指定的是子串的开始位置和长度
    if (r != null) {
      // 对参数值进行解码
      return decodeURIComponent(r[2])
    }
    var array = ['zjtze', 'zjain', 'zjaiy', 'zjzze', 'zjaip', 'zjaik', 'zcaie', 'zcaia', 'zjaio', 'zjzne', 'zjaij', 'zjaix', 'zjaib', 'zjaiz', 'zjaiu', 'zjaih', 'zddje']
    if (name == 'appId') {
      var areas = window.location.hostname.split('.')[0].indexOf('www') > -1 ? window.location.hostname.split('.')[1] : window.location.hostname.split('.')[0]
      if (array.indexOf(areas) > -1) {
        return areas
      } else {
        return 'zjsqe'
      }
    } else {
      return ''
    }
  }
  //寻找某个链接参数
  Vue.prototype.getQueryUrl = function (url, name) {
    if (!url || !name) return
    // 正则：[找寻'&' + 'url参数名字' = '值' + '&']（'&'可以不存在）
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    let r = url.split('?')[1].match(reg) //substr() 的参数指定的是子串的开始位置和长度
    if (r != null) {
      // 对参数值进行解码
      return decodeURI(r[2])
    }
    return ''
  }
  //是否为图片
  Vue.prototype.isPic = function (url) {
    if ((url && typeof url == 'string' && url.indexOf('.png') > 0) || (url && typeof url == 'string' && url.indexOf('.jpg') > 0)) {
      return true
    }
    return false
  }
  //是否为文件
  Vue.prototype.isFile = function (link) {
    if (link && (link.indexOf('xlsx') > -1 || link.indexOf('pptx') > -1 || link.indexOf('docx') > -1 || link.indexOf('txt') > -1)) {
      return true
    }
    return false
  }
  //是否为视频
  Vue.prototype.isVideo = function (val) {
    var ty = false
    if (val && val.indexOf('.mp4') > 0) {
      ty = true
    }
    if (val && val.indexOf('.flv') > 0) {
      ty = true
    }
    if (val && val.indexOf('.rmvb') > 0) {
      ty = true
    }
    if (val && val.indexOf('.wmv') > 0) {
      ty = true
    }
    if (val && val.indexOf('.avi') > 0) {
      ty = true
    }
    if (val && val.indexOf('.mov') > 0) {
      ty = true
    }
    if (val && val.indexOf('.rm') > 0) {
      ty = true
    }
    return ty
  }
  Vue.prototype.initFloorDrag = function () {
    var methodsEvent = {
      //百分数转为小数
      toPoint: function (percent) {
        var str = percent.replace('%', '')
        str = str / 100
        return str
      },
      //小数转为百分数
      toPercent: function (point, floor) {
        if (floor == 1) {
          point = Math.floor(Number(point * 10000))
        } else if (floor == 0) {
          point = Math.ceil(Number(point * 10000))
        } else {
          point = Number(point * 10000)
        }
        //var str=point.toFixed(2);
        var str = Math.floor(point) / 100
        str += '%'
        return str
      },
      //缩放开始给外链iframe添加遮罩层，避免缩放卡顿
      addIframeFix: function (flag) {
        var $iframe = $('iframe')
        if (flag) {
          $iframe = $('iframe')
        }
        $iframe.each(function () {
          $("<div class='ui-resizable-iframeFix' style='background:#fff'></div>")
            .css({
              width: this.offsetWidth + 'px',
              height: this.offsetHeight + 'px',
              position: 'absolute',
              opacity: '0.001',
              zIndex: 89
            })
            .css($(this).offset())
            .appendTo('body')
        })
      },
      //缩放结束移除遮罩层
      removeIframeFix: function (flag) {
        var $iframe = $('div.ui-resizable-iframeFix')
        if (flag) {
          $iframe = $('div.ui-resizable-iframeFix')
        }
        document.onmousemove = document.onmouseup = null
        $iframe.each(function () {
          this.parentNode.removeChild(this)
        })
      },
      //生成辅助线
      AuxiliaryLine: function (x, y) {
        var hh = $(window).height() //获取页面容器的高度；
        $('#h-line').css('top', y)
        $('#a-line').css('height', hh)
        $('#a-line').css('left', x)
        $('#h-line').css('display', 'block')
        $('#a-line').css('display', 'block')
      },
      //移除辅助线
      stopAuxiliaryLine: function () {
        $('#h-line').css('display', 'none')
        $('#a-line').css('display', 'none')
      }
    }
    //小数转为百分数
    function toPercent(point, floor) {
      if (floor == 1) {
        point = Math.floor(Number(point * 100))
      } else {
        point = Math.ceil(Number(point * 100))
      }
      var str = point.toFixed(1)
      str += '%'
      return str
    }
    function addIframeFix(flag) {
      var $iframe = $('iframe')
      if (flag) {
        $iframe = $('iframe')
      }
      $iframe.each(function () {
        $("<div class='ui-resizable-iframeFix' style='background:#fff'></div>")
          .css({
            width: this.offsetWidth + 'px',
            height: this.offsetHeight + 'px',
            position: 'absolute',
            opacity: '0.001',
            zIndex: 89
          })
          .css($(this).offset())
          .appendTo('body')
      })
    }
    function removeIframeFix(flag) {
      var $iframe = $('div.ui-resizable-iframeFix')
      if (flag) {
        $iframe = $('div.ui-resizable-iframeFix')
      }
      document.onmousemove = document.onmouseup = null
      $iframe.each(function () {
        this.parentNode.removeChild(this)
      })
    }
    //左右拖动
    var nexDomHeight = 326
    var opposedDomHeight = 0
    var allDomHeight = 0
    if ($('.content-left-box').length) {
      $('.content-left-box').resizable({
        handles: 'e',
        start: function (event, ui) {
          addIframeFix(false)
          nexDomHeight = $(event.target).next().width() // 下一个元素实际高度
          opposedDomHeight = $(event.target).next().next().width()
        },
        resize: function (event, ui) {
          var orgW = ui.originalSize.width // 当前元素高度
          var curW = ui.size.width // 移动后元素高度
          var scrollW = curW - orgW // 移动的高度
          if (opposedDomHeight) {
            if (opposedDomHeight + ui.size.width + 24 >= $(event.target).parent().width()) {
              $(event.target).css('width', $(event.target).parent().width() - 24 - opposedDomHeight + 'px')
              return false
            }
          } else {
            if (ui.size.width + 24 >= $(event.target).parent().width()) {
              $(event.target).css('width', $(event.target).parent().width() - 24 + 'px')
              return false
            }
          }
          $(event.target)
            .next()
            .css('width', nexDomHeight - scrollW - 2 + 'px')
          $(event.target).next().find('.bottom-content').css('overflowX', 'auto')
          var x = event.pageX
          var y = event.pageY
          methodsEvent.AuxiliaryLine(x, y)
        },
        stop: function (e, ui) {
          methodsEvent.stopAuxiliaryLine()
          removeIframeFix(false)
        }
      })
    }
    if ($('.content-right-box').length) {
      $('.content-right-box').resizable({
        handles: 'w',
        start: function (event, ui) {
          addIframeFix(false)
          nexDomHeight = $(event.target).prev().width() // 下一个元素实际高度
          opposedDomHeight = $(event.target).prev().prev().width()
        },
        resize: function (event, ui) {
          var orgW = ui.originalSize.width // 当前元素高度
          var curW = ui.size.width // 移动后元素高度
          var scrollW = curW - orgW // 移动的高度
          // if((opposedDomHeight + ui.size.width + 24)>=$(event.target).parent().width()){
          //   $(event.target).prev().css("width", (nexDomHeight) + 'px');
          //   return false;
          // }

          if (opposedDomHeight) {
            if (opposedDomHeight + ui.size.width + 24 >= $(event.target).parent().width()) {
              $(event.target).css('width', $(event.target).parent().width() - 24 - opposedDomHeight + 'px')
              $(event.target).css('left', '0px')
              return false
            }
          } else {
            if (ui.size.width + 24 >= $(event.target).parent().width()) {
              $(event.target).css('width', $(event.target).parent().width() - 24 + 'px')
              return false
            }
          }
          $(event.target)
            .prev()
            .css('width', nexDomHeight - scrollW + 'px')
          $(event.target).prev().find('.bottom-content').css('overflowX', 'auto')
          $(event.target).css('left', '0px')
          var x = event.pageX
          var y = event.pageY
          methodsEvent.AuxiliaryLine(x, y)
        },
        stop: function (e, ui) {
          methodsEvent.stopAuxiliaryLine()
          removeIframeFix(false)
        }
      })
    }
    if ($('.content-top-box').length) {
      //上下拖动
      $('.content-top-box').resizable({
        handles: 's',
        minHeight: '30',
        start: function (event, ui) {
          addIframeFix(true)
          nexDomHeight = $(event.target).next().height() // 下一个元素实际高度
          opposedDomHeight = $(event.target).next().next().height()
          allDomHeight = $(event.target).parents('.block-content').height()
        },
        resize: function (event, ui) {
          var orgH = ui.originalSize.height // 当前元素高度
          var curH = ui.size.height - 1 // 移动后元素高度
          var scrollH = curH - orgH // 移动的高度
          if (curH <= 62) {
            $(event.target).css('height', 62 + 'px')
            $(event.target)
              .next()
              .find('.bottom-switch')
              .css('height', nexDomHeight - 36 + 'px')
            return false
          }
          if (ui.size.height >= orgH + nexDomHeight - 36) {
            $(event.target).css('height', orgH + nexDomHeight - 36 + 'px')
            return false
          }
          $(event.target)
            .next()
            .find('.bottom-switch')
            .css('height', nexDomHeight - scrollH - 37 + 'px')
          $(event.target).parents('.block-content').css('height', allDomHeight)
          var x = event.pageX
          var y = event.pageY
          methodsEvent.AuxiliaryLine(x, y)
        },
        stop: function (e, ui) {
          methodsEvent.stopAuxiliaryLine()
          removeIframeFix(true)
        }
      })
    }
    if ($('.content-bottom-box').length) {
      $('.content-bottom-box').resizable({
        handles: 'n',
        minHeight: '30',
        start: function (event, ui) {
          addIframeFix(true)
          nexDomHeight = $(event.target).prev().outerHeight() // 下一个元素实际高度
          opposedDomHeight = $(event.target).prev().prev().height()
          allDomHeight = $(event.target).parents('.block-content').height()
        },
        resize: function (event, ui) {
          var orgH = ui.originalSize.height // 当前元素高度
          var curH = ui.size.height // 移动后元素高度
          var scrollH = curH - orgH // 移动的高度

          if (curH <= 62) {
            $(event.target).css('height', 62 + 'px')
            // console.log(allDomHeight - opposedDomHeight - 62 - 40)
            $(event.target)
              .prev()
              .find('.bottom-switch')
              .css('height', allDomHeight - opposedDomHeight - 40 - 62 + 'px')
            $(event.target).css('top', 'auto')
            return false
          }
          if (ui.size.height >= orgH + nexDomHeight - 36) {
            $(event.target).css('height', orgH + nexDomHeight - 36 + 'px')
            $(event.target).css('top', 'auto')
            return false
          }
          $(event.target)
            .prev()
            .find('.bottom-switch')
            .css('height', nexDomHeight - scrollH - 36 + 'px')
          $(event.target).css('top', 'auto')
          $(event.target).parents('.block-content').css('height', allDomHeight)
        },
        stop: function (e, ui) {
          methodsEvent.stopAuxiliaryLine()
          removeIframeFix(true)
        }
      })
    }
  }
  //改变textarea高度属性
  Vue.prototype.autoTextarea = function (elem, extra, maxHeight) {
    extra = extra || 0
    var isFirefox = !!document.getBoxObjectFor || 'mozInnerScreenX' in window,
      isOpera = !!window.opera && !!window.opera.toString().indexOf('Opera'),
      addEvent = function (type, callback) {
        elem.addEventListener ? elem.addEventListener(type, callback, false) : elem.attachEvent('on' + type, callback)
      },
      getStyle = elem.currentStyle
        ? function (name) {
            var val = elem.currentStyle[name]
            if (name === 'height' && val.search(/px/i) !== 1) {
              var rect = elem.getBoundingClientRect()
              return rect.bottom - rect.top - parseFloat(getStyle('paddingTop')) - parseFloat(getStyle('paddingBottom')) + 'px'
            }
            return val
          }
        : function (name) {
            return getComputedStyle(elem, null)[name]
          },
      minHeight = parseFloat(getStyle('height'))
    elem.style.resize = 'none'
    var change = function () {
      var scrollTop,
        height,
        padding = 0,
        style = elem.style
      if (elem._length === elem.value.length) return
      elem._length = elem.value.length
      if (!isFirefox && !isOpera) {
        padding = parseInt(getStyle('paddingTop')) + parseInt(getStyle('paddingBottom'))
      }
      scrollTop = document.body.scrollTop || document.documentElement.scrollTop
      elem.style.height = minHeight + 'px'
      if (elem.scrollHeight > minHeight) {
        if (maxHeight && elem.scrollHeight > maxHeight) {
          height = maxHeight - padding
          style.overflowY = 'auto'
        } else {
          height = elem.scrollHeight - padding
          style.overflowY = 'hidden'
        }
        style.height = height + extra + 'px'
        scrollTop += parseInt(style.height) - elem.currHeight
        document.body.scrollTop = scrollTop
        document.documentElement.scrollTop = scrollTop
        elem.currHeight = parseInt(style.height)
      }
    }
    addEvent('propertychange', change)
    addEvent('input', change)
    addEvent('focus', change)
    change()
  }
  //下载文件
  Vue.prototype.downLoad = function (dataType, title, originUrl, contentIds) {

    var _this = this
    // if(_this.$store.state.userInfo.userId){
    $.ajax({
      url: _this.$store.state.baseURL + '/zciid-deliverable/api/deliverable/manage/addInfo',
      data: {
        //固定：2
        operateType: '2',
        //当前登录人userId
        userId: _this.$store.state.userInfo.userId ? _this.$store.state.userInfo.userId : localStorage.getItem('noLoginSid'),
        //交付物名称
        name: document.title,
        //交付物url eg：https://520emv.com/xxx,
        deliverableUrl: location.href,
        //交付物id 数据id(或其他唯一标识)-type2   eg：UUID-type2
        deliverableId:
          (contentIds ||
            _this.getQuery('docId') ||
            _this.getQuery('thirdUrl') ||
            _this.getQuery('productUrl') ||
            _this.getQuery('deviceId') ||
            _this.getQuery('devicekbId') ||
            _this.getQuery('platformUrl') ||
            _this.getQuery('id') ||
            _this.$contentId ||
            _this.getQuery('pfId') ||
            _this.getQuery('emailId') ||
            _this.getQuery('ywId') ||
            _this.getQuery('exploitId')) + '-type2',
        img: $('img.z-image').length ? $('img.z-image')[0].src : '',
        downloadType: 'wz'
      },
      type: 'GET',
      dataType: 'json'
    })
    // }

    let protocalUrl = 'znrclient://'
    var desk = title ? title : window.document.title
    var link = originUrl ? originUrl : dataType ? window.location.href.replace('flowDetail', 'odzid') + '&dataType=' + dataType : window.location.href
    if (window.location.href.indexOf('520ezj') == -1 && navigator.userAgent.indexOf('Electron') == -1) {
      openUriWithInputTimeoutHack(
        protocalUrl,
        () => {
          // 如果没有打开应用
          var desks = '' + desk + '.url'
          var urls = '[InternetShortcut]' + '\n' + 'URL=' + link
          saveToDesktop(desks, urls)
        },
        () => {
          // 浏览器弹窗提示
          downloads(desk, link)
        }
      )
    } else {
      downloads(desk, link)
    }

    /**
     * uri 打开客户端的uri
     * failCb 打开客户端失败回调
     * successCb 打开客户端成功回调
     */
    function openUriWithInputTimeoutHack(uri, failCb, successCb) {
      let target = document.createElement('input')
      target.style.width = '0'
      target.style.height = '0'
      target.style.position = 'fixed'
      target.style.top = '0'
      target.style.left = '0'
      document.body.appendChild(target)

      target.focus()
      var handler = _registerEvent(target, 'blur', onBlur)
      function onBlur() {
        successCb && successCb()
        handler.remove()
        clearTimeout(timeout)
        document.body.removeChild(target)
      }

      //will trigger onblur
      location.href = uri

      // Note: timeout could vary as per the browser version, have a higher value
      var timeout = setTimeout(function () {
        failCb && failCb()
        handler.remove()
        document.body.removeChild(target)
      }, 1000)
    }

    function _registerEvent(target, eventType, cb) {
      if (target.addEventListener) {
        target.addEventListener(eventType, cb)
        return {
          remove: function () {
            target.removeEventListener(eventType, cb)
          }
        }
      } else {
        target.attachEvent(eventType, cb)
        return {
          remove: function () {
            target.detachEvent(eventType, cb)
          }
        }
      }
    }

    function downloads(desk, link) {
      var text = JSON.stringify({ title: desk, url: link }) //要保存的内容
      var blob = new Blob([text], { type: 'text/plain' })
      var anchor = document.createElement('a')
      anchor.download = desk + (window.location.href.indexOf('520ezj') > -1 ? '.zjs' : '.znr')
      anchor.href = window.URL.createObjectURL(blob)
      anchor.target = '_blank'
      anchor.style.display = 'none' // just to be safe!
      document.body.appendChild(anchor)
      anchor.click()
      document.body.removeChild(anchor)
    }
    function saveToDesktop(fileName, data) {
      var explorer = u.toLowerCase()
      if (explorer.indexOf('trident') > 0) {
        //IE 5+
        var wss = new ActiveXObject('WScript.Shell')
        var desktopUrl = wss.SpecialFolders('Desktop')
        var fso = new ActiveXObject('Scripting.FileSystemObject')
        var tf = fso.CreateTextFile(desktopUrl + '\\' + fileName, true)
        tf.Write(data)
        tf.Close()
      } else {
        //fireFox chrome
        var urlObj = window.URL || window.webkitURL || window
        var blob = new Blob([data])
        var link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a')
        link.href = urlObj.createObjectURL(blob)
        link.download = fileName
        saveClick(link)
      }

      function saveClick(obj) {
        var e = document.createEvent('MouseEvents')
        e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
        obj.dispatchEvent(e)
      }
    }
  }
  //存储cookie
  Vue.prototype.setCookie = function (sKey, sValue, sPath, sDomain, vEnd, bSecure) {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
      return false
    }
    var sExpires = ''
    if (vEnd) {
      switch (vEnd.constructor) {
        case Number:
          sExpires = vEnd === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : '; max-age=' + vEnd
          break
        case String:
          sExpires = '; expires=' + vEnd
          break
        case Date:
          sExpires = '; expires=' + vEnd.toUTCString()
          break
      }
    }
    document.cookie = encodeURIComponent(sKey) + '=' + encodeURIComponent(sValue) + sExpires + (sDomain ? '; domain=' + sDomain : '') + (sPath ? '; path=' + sPath : '') + (bSecure ? '; secure' : '')
    return true
  }
  //是否存在cookie
  Vue.prototype.hasCookie = function (sKey) {
    return new RegExp('(?:^|;\\s*)' + encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&') + '\\s*\\=').test(document.cookie)
  }
  //删除cookie
  Vue.prototype.removeCookie = function (sKey, cvalue, exdays) {
    if (!sKey || !this.hasCookie(sKey)) {
      return false
    }
    var d = new Date()
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
    var expires = 'expires=' + d.toUTCString()
    document.cookie = sKey + '=' + cvalue + '; ' + expires + '; path=/'
    return true
  }
  //获取cookie
  Vue.prototype.getCookie = function (sKey) {
    return decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null
  }
  //判断是否为链接
  Vue.prototype.isUrl = function (str) {
    var reg = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/.*)?$/i
    var isurl = reg.test(str) //test(str)方法是js正确表达式内置的对象可以直接调用
    return isurl
  }
  //判断是否有右键数据缓存
  Vue.prototype.rightData = function (data, content) {
    var ID = data.flowId || data.blockId || ''
    if (ID) {
      sessionStorage.setItem(data.types + ID, JSON.stringify(content))
      var rightData = JSON.parse(sessionStorage.getItem('rightData')) || []
      if (rightData.length == 10) {
        var name = rightData.shift()
        sessionStorage.removeItem(name)
        rightData.push(data.types + ID)
        sessionStorage.setItem('rightData', JSON.stringify(rightData))
      } else {
        rightData.push(data.types + ID)
        sessionStorage.setItem('rightData', JSON.stringify(rightData))
      }
    }
  }
  //右键数据拼接处理
  Vue.prototype.addRightData = function (data, content, initData) {
    var _this = this,
      datas = { [content]: initData[content], userId: _this.$store.state.userInfo.userId }
    if (initData.types == '531') {
      _this.$http.get('/zciid-deliverable/api/webapp/quote/getFlow.json', datas).then((res) => {
        if (res.state == 1) {
          var contArr = [{ boxNewList: res.data.one.boxNewList, menuLevel: 1, menuName: 'topMenu' }]
          res.data.two.forEach((ele) => {
            contArr.push(ele)
          })
          data.push(...contArr)
        }
        _this.$store.commit('setRightMenu', { menu: data, append: '', type: initData.type })
        _this.rightMenus = _this.$store.state.rightMenu
        _this.rightData(data, _this.$store.state.rightMenu)
      })
    } else {
      _this.$store.commit('setRightMenu', { menu: data, append: '', type: initData.type })
      _this.rightMenus = _this.$store.state.rightMenu
      _this.rightData(data, _this.$store.state.rightMenu)
    }
  }
  //是否为移动端
  Vue.prototype.IsMobile = function () {
    let agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPod', 'iPad']
    for (let i = 0; i < agents.length; i++) {
      if (u.indexOf(agents[i]) >= 0) return true
    }
    return false
  }
  // 本地存值函数
  Vue.prototype.setCanExpireLocal = function (key, value, expire) {
    let obj = {
      data: value, //存储值
      time: Date.now(), //存值时间戳
      expire: expire //过期时间
    }
    localStorage.setItem(key, JSON.stringify(obj))
    if(key == 'rightData'){
      var rightData = JSON.parse(localStorage.getItem('rightData')) || []
      //只存10条数据
      if (rightData.length == 20) {
        var name = rightData.shift()
        localStorage.removeItem(name)
        rightData.push(key)
        localStorage.setItem('rightData', JSON.stringify(rightData))
      } else {
        rightData.push(key)
        localStorage.setItem('rightData', JSON.stringify(rightData))
      }
    }
  }
  // 本地存值函数
  Vue.prototype.getCanExpireLocal = function (key) {
    let val = localStorage.getItem(key)
    // 如果没有值就直接返回null
    if (!val) return val
    val = JSON.parse(val)
    // 如果当前时间戳大于过期时间戳说明过期了，删除值并返回null
    if (Date.now() > val.time + val.expire) {
      var rightData = JSON.parse(localStorage.getItem('rightData')) || []
      var ind = rightData.indexOf(key)
      if (ind > -1) {
        rightData.splice(ind, 1)
      }
      localStorage.setItem('rightData', JSON.stringify(rightData))
      localStorage.removeItem(key)
      return null
    }
    return val.data
  }
  window.rightMenuArray = []
  // 计算右边空白距离，改变右键出现位置
  Vue.prototype.rightAreaChange = function (data, left) {
    $('.el-cascader-panel .el-scrollbar.new').remove()
    //计算右边空白距离，改变右键出现位置
    if ($('.right-menu .el-cascader-menu.el-scrollbar:last').css('position') == 'absolute') {
      if (window.innerWidth - left - $('.right-menu').width() > 0) {
        fold(data)
      }
    } else {
      if (window.innerWidth - left - $('.right-menu').width() < 150) {
        fold(data)
      }
    }
    window.rightMenuArray = data
    //判断折叠
    function fold(data) {
      if (window.rightMenuArray.length < data.length) {
        $('.right-menu .el-cascader-menu.el-scrollbar:last').prev().empty()
        $('.el-cascader-panel.is-bordered').css('border', '0')
        if ($('.right-menu .el-cascader-menu.el-scrollbar:last').css('right') == '127px') {
          setTimeout(() => {
            $('.right-menu .el-cascader-menu.el-scrollbar:last').css({ position: 'absolute', backgroundColor: 'white', right: '0' })
          }, 1)
        } else {
          setTimeout(() => {
            $('.right-menu .el-cascader-menu.el-scrollbar:last').css({ position: 'absolute', backgroundColor: 'white', right: '127px' })
          }, 1)
        }
      }
    }
  }
  // 通用分享
  Vue.prototype.shareUniversal = function (e, url, title, picurl, summary, erweima) {
    var _this = this
    if (e.data && typeof e.data == 'string' && e.data.indexOf('webpackHotUpdate') == -1) {
      var name = e.data.split('-')[0]
      let text = _this.$store.state.baseURL + '/uoqid/weixin?url=' + url
      switch (name) {
        case '微信朋友圈':
          _this.judge('WEIXIN_CIRCLE', url, title, picurl, summary, text + '&WX=1', '微信朋友圈', erweima, 'specail')
          break
        case '新浪微博':
          var _shareUrl = 'https://service.weibo.com/share/share.php?' //真实的appkey ，必选参数
          _shareUrl += 'url=' + url //参数url设置分享的内容链接|默认当前页location，可选参数
          _shareUrl += '&title=' + title //参数title设置分享的标题|默认当前页标题，可选参数
          _shareUrl += '&pic=' + picurl.replace(/https/g, 'http') //参数pic设置图片链接|默认为空，可选参数
          _this.judge('SINA', url, title, picurl, summary, _shareUrl, '新浪微博', erweima, 'specail')
          break
        case 'QQ空间':
          var _shareUrl = 'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?'
          _shareUrl += 'url=' + url //参数url设置分享的内容链接|默认当前页urllocation
          _shareUrl += '&title=' + title //参数title设置分享标题title，可选参数
          _shareUrl += '&summary=' + summary //参数title设置分享标题title，可选参数
          _shareUrl += '&pics=' + picurl //参数pic设置图片链接|默认为空，可选参数
          _this.judge('QZONE', url, title, picurl, summary, _shareUrl, 'QQ空间', erweima, 'specail')
          break
        case 'QQ':
          var shareqqzonestring = ' http://connect.qq.com/widget/shareqq/index.html?title=' + title + '&url=' + url + '&pic=' + picurl
          _this.judge('QQ', url, title, picurl, summary, shareqqzonestring, 'QQ', erweima, 'specail')
          break
        case '微信好友':
          _this.judge('WEIXIN', url, title, picurl, summary, text + '&WX=1', '微信好友', erweima, 'specail')
          break
        case '微信':
          _this.judge('WEIXIN', url, title, picurl, summary, text + '&WX=1', '微信', erweima, 'specail')
          break
        case '抖音':
          _this.judge('DOUYIN', url, title, picurl, summary, e.data.split('-')[1], '抖音', erweima)
          break
        case '钉钉':
          _this.judge('DINGTALK', url, title, picurl, summary, text + '&DD=1', '钉钉好友', erweima)
          break
        case '快手':
          _this.judge('KUAISHOU', url, title, picurl, summary, e.data.split('-')[1], '快手', erweima)
          break
        default:
          if (_this.IsMobile()) {
            jumpToApp('', e.data.split('-')[1], '', '', '', name, JSON.parse('{' + e.data.split('{')[1]), erweima)
          } else {
            _this.open(e.data.split('-')[1], '_blank')
          }
      }
    }
  }
  // 通用分享
  Vue.prototype.judge = function (name, url, title, picurl, summary, link, ZNname, erweima, specail) {
    if (this.IsMobile()) {
      this.jumpToApp(name, url, title, picurl, summary, '', '', erweima)
    } else {
      if (top.window.require) {
        if (specail) {
          this.specialTreatment({ url: link, data: '' })
        } else {
          this.specialTreatment(link, ZNname)
        }
      } else {
        this.open(link, '_blank', name)
      }
    }
  }
  // 通用分享
  Vue.prototype.specialTreatment = function (sendData, ZNname) {
    var ipcRender = top.window.require('electron').ipcRenderer
    //发送指令
    try {
      if (ZNname) {
        ipcRender.send('openWindow', { title: ZNname, url: sendData })
      } else {
        ipcRender.send('openShareWindow', sendData)
      }
    } catch (e) {
      console.log('不支持ipcRenderer')
    }
  }
  // 通用分享
  Vue.prototype.jumpToApp = function (shareSDK, url, title, picurl, summary, name, describes, erweima) {
    var _this = this,
      map = {}
    if (name) {
      //新打开页面
      map = {
        handleName: 'pushNewWebScene',
        params: {
          link: url,
          hiddenNavigation: '0',
          code: '0'
        }
      }
    } else {
      //第三方分享
      map = {
        handleName: 'appShareInterface',
        params: {
          shareSDK: shareSDK,
          shareType: ['DOUYIN', 'KUAISHOU'].includes(shareSDK) || erweima ? 'image' : 'link',
          title: title,
          icon: picurl,
          link: url,
          describe: summary
        }
      }
    }
    if (shareSDK == 'dsf') {
      //唤醒app
      if (title == '京东') {
        map = {
          handleName: 'zdy_thirdAPP',
          params: {
            content: '{"describes": "zdy_thirdAPPdetail","redirectUrl": "' + picurl + '","iOS": "openApp.jdMobile://","Android":"com.jingdong.app.mall"}'
          }
        }
      } else {
        map = {
          handleName: 'zdy_thirdAPP',
          params: {
            content: url
          }
        }
      }
    }
    _this.postToApp(map, name, describes, url)
  }
  //判断是否为APP
  Vue.prototype.IsApp = function () {
    var ua = u.toLowerCase()
    return {
      APP: ua.match(/cmeplaza/i) == 'cmeplaza' && !ua.match(/electron/i),
      androidIs: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
      iOS: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
    }
  }
  //传值到APP
  Vue.prototype.postToApp = function (map, name, describes, url) {
    var ua = u.toLowerCase()
    var androidIs = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
    var iOSIs = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
    if (ua.match(/cmeplaza/i) == 'cmeplaza' && !ua.match(/electron/i)) {
      if (androidIs) {
        if (describes && describes.describes == 'zdy_thirdAPP') {
          //唤醒app
          map = {
            handleName: 'wakeUpAPP',
            params: {
              wakeUpLink: describes.Android,
              APPName: name
            }
          }
        }
        //安卓端返回
        window.androidAppModel.postMessage(JSON.stringify(map))
      } else if (iOSIs) {
        if (describes && describes.describes == 'zdy_thirdAPP') {
          window.location.href = describes.iOS
        }
        //苹果端返回
        window.webkit.messageHandlers.iOSAppModel.postMessage(map)
      }
      return false
    } else {
      if (self != top && self.name == 'toolsFrame') {
        parent.addBread(name, url)
      }
      return true
    }
  }
  // 转发
  Vue.prototype.retransmission = function () {
    layer.open({
      id: 1,
      type: 1,
      title: '请输入标题',
      skin: 'layui-layer-rim',
      area: ['450px', '200px'],
      content:
        ' <div class="row" style="width: 420px;  margin-left:7px; margin-top:10px;">' +
        '<div class="col-sm-12">' +
        '<div class="input-group">' +
        '<span class="input-group-addon"></span>' +
        '<input id="transTit" type="text" class="form-control" placeholder="请输入标题" style="width: calc(100% - 20px);border: 1px solid #ddd;height: 30px;line-height: 30px;"/>' +
        '</div>' +
        '</div>',
      btn: ['保存', '取消'],
      btn1: function (index, layero) {
        var tit = $('#transTit').val()
        var _url = window.location.href
        var obj = {
          imgUrl: '',
          thirdPartyName: '元宇宙展示分享',
          leaveWord: '',
          link: _url,
          title: tit,
          desc: ''
        }
        var content = encodeURIComponent(JSON.stringify(obj))
        layer.open({
          id: 'transpond',
          type: 2,
          title: '转发',
          fixed: true,
          maxmin: true,
          area: ['100%', '100%'],
          content: '/aassid/chat/repeat?content=' + content + '&contentType=193',
          close: function () {}
        })
      },
      btn2: function (index, layero) {
        layer.close(index)
      }
    })
  }
  // 打印
  Vue.prototype.toPrint = function () {
    function loadJS(url) {
      var script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = url
      document.body.appendChild(script)
    }
    loadJS('https://520ezj.com//zjstatic/standard/js/html2canvas.js')
    loadJS('https://520ezj.com//zjstatic/standard/project/myExcel-master/js/jqprint.js')
    setTimeout(() => {
      new html2canvas(document.getElementsByTagName('body')[0], {
        backgroundColor: 'transparent',
        allowTaint: true,
        useCORS: true
      }).then((canvas) => {
        // canvas为转换后的Canvas对象
        let oImg = new Image()
        oImg.src = canvas.toDataURL() // 导出图片
        oImg.style.width = '100%' //设置打印图100%显示
        $(oImg).jqprint()
      })
      this.$message({
        center: true,
        message: '生成中...',
        duration: 2000
      })
    }, 300)
  }
  //打开通讯浮层
  Vue.prototype.openLayer = async function (title, url, titleName, userArr) {
    var _this = this,
      num = 0,
      timeOut = null,
      openTimes = null,
      layerInd = null
    if ($('.communication').length) {
      $('.communication .title').text(title)
      $('.communication iframe').attr('src', url)
      return
    }
    var html =
      '<div class="communication" ' +
      (_this.$route.name == 'Next' ? 'style="right:40px"' : '') +
      '><div class="supFloat txun"></div><div class="layer-title"><span class="title">' +
      title +
      '</span><span class="layui-layer-setwin"><a href="javascript:;" class="layui-layer-min"><cite></cite></a><a href="javascript:;" class="layui-layer-ico layui-layer-max"></a><a href="javascript:;" class="layui-layer-ico layui-layer-close layui-layer-close1"></a></span></div><iframe id="suspension" src="' +
      url +
      '" frameborder="0" allow="fullscreen ;camera; microphone"></iframe></div>'
    $('body').append(html)
    openTimes = setInterval(() => {
      if (!$('.communication').length || ($('.communication').length && $('.communication iframe')[0].contentWindow.$('#videos video').length > 0)) {
        clearInterval(openTimes)
        clearTimeout(timeOut)
        layer.close(layerInd)
        num = 0
      }
    }, 1000)
    this.Drags('.communication')
    $(document).on('click', '.communication .layui-layer-min', function () {
      $(this).hide()
      $(this).next().addClass('layui-layer-maxmin')
      $('.communication').css({ width: '180px', height: '30px', bottom: '0', right: document.documentElement.clientWidth - 180 + 'px' })
    })
    $(document).on('click', '.communication .layui-layer-max', function (e) {
      $(this).prev().hide()
      $(this).addClass('layui-layer-maxmin max')
      $('.communication').css({ width: '100%', height: '100%', left: '0', top: '0' })
    })
    $(document).on('click', '.communication .layui-layer-maxmin', function (e) {
      $(this).prev().show()
      $(this).removeClass('layui-layer-maxmin max')
      $('.communication').removeAttr('style')
    })
    $(document).on('click', '.communication .layui-layer-ico.layui-layer-close.layui-layer-close1', function (e) {
      $('.communication ').remove('')
      $('.kefu.supFloat').parent().removeClass('curr')
      clearTimeout(timeOut)
    })
    if (title == '语音通讯' || title == '视频通讯') {
      var array = _this.$store.state.Receiver || []
      if (window.location.href.indexOf('blockId') > -1 && window.location.search) {
        if (userArr.length > 1) {
          array = userArr
        } else {
          let res = await this.$http.get('/acnid-project-approve/circleuser/open/selectUserInfoByAppIdOrCircleId.json?', { appId: this.getQuery('appId') })
          if (res.state == 1) {
            // res.data.map(tag => tag.userName = tag.trueName);
            array = res.data.filter((tag) => tag.userId != userArr[0].userId)
            array.unshift(userArr[0])
            // array = res.data;
            // array.unshift(userArr[0]);
          }
        }
      }

      function time() {
        clearTimeout(timeOut)
        timeOut = setTimeout(function () {
          if ($('.communication').length && $('.communication iframe')[0].contentWindow.$('#videos video').length < 1 && array.length > 1) {
            // if(true){
            var times
            layerInd = layer.open({
              id: 1,
              type: 0,
              title: '小元助理',
              content: (array[num].trueName || array[num].userName) + '未接听，将转接给小元助理' + (array[num + 1].trueName || array[num].userName) + '接听，是否转接？',
              btn: ['确定', '取消'],
              btn1: function (index, layero) {
                num++
                _this.getSpecialUrl(title == '语音通讯' ? '182' : '183', title, array[num].userId, titleName)
                // clearInterval(times);
                clearTimeout(timeOut)
                layer.close(index)
                if (num < array.length - 1) {
                  time()
                }
              },
              btn2: function (index, layero) {
                // clearInterval(times);
                clearTimeout(timeOut)
                layer.close(index)
                num = 0
              },
              success: function (layero, index) {
                // times = setInterval(()=>{
                //   if(!$('.communication').length || $('.communication').length && $('.communication iframe')[0].contentWindow.$("#videos video").length > 0){
                //     clearInterval(times);
                //     clearTimeout(timeOut);
                //     layer.close(index);
                //     num = 0
                //   }
                // },1000)
              },
              cancel: function (index, layero) {
                // clearInterval(times);
                clearTimeout(timeOut)
                num = 0
              }
            })
          }
        }, 30000)
      }
      time()
    }
  }
  //拖动
  Vue.prototype.Drags = function (dom) {
    var _this = this
    var box = document.querySelector(dom),
      x1,
      y1,
      x2,
      y2,
      l,
      t,
      tempX,
      tempY,
      flag = false,
      targets,
      isMove = false,
      visibleTop = 0,
      lastX,
      lastY
    if (!box) return
    //记录初始化位置bottom
    window.$bottom = parseInt(_this.getElementStyle(document.querySelector(dom), 'bottom'))
    var scales, height, width, transform, targetClassName, pass

    function down(e) {
      ;(targetClassName = e.target.className), (pass = !targetClassName || targetClassName.indexOf('supFloat') == -1), (height = document.documentElement.clientHeight), (width = document.documentElement.clientWidth), (transform = _this.getElementStyle(document.getElementById('app'), 'transform'))
      //判断是否为拖动块
      if (pass) return

      if (transform && transform != 'none') {
        scales = transform.split(',')[3]
      }
      window.click_debug = true
      flag = true
      // 获取鼠标在div上按下的位置
      // var e = window.event;  //接收事件对象
      // 获取鼠标在当前事件源的位置
      x1 = e.touches ? e.touches[0].pageX : e.offsetX
      y1 = e.touches ? e.touches[0].pageY : e.offsetY
      tempX = parseInt($(dom).css('left') + 0)
      tempY = parseInt($(dom).css('top') + 0)
      if (targetClassName == 'layer-title') {
        targets = true
      } else {
        targets = false
      }
    }
    function move(e) {
      if (pass) return
      window.click_debug = false
      if (lastX !== null && lastY !== null) {
        const dx = (e.touches ? e.touches[0].pageX : e.clientX) - lastX
        const dy = (e.touches ? e.touches[0].pageY : e.clientY) - lastY

        if ((Math.abs(dx) > 0 || Math.abs(dy) > 0) && flag) {
          // 鼠标移动了一定的距离
          isMove = true
        }
      }
      lastX = e.touches ? e.touches[0].pageX : e.clientX
      lastY = e.touches ? e.touches[0].pageY : e.clientY

      if (isMove) {
        // 获取鼠标在浏览器中的位置
        // var e = window.event;
        x2 = e.touches ? tempX + e.touches[0].pageX : e.clientX
        y2 = e.touches ? tempY + e.touches[0].pageY : e.clientY - (targetClassName && targetClassName.indexOf('kefu') > -1 ? e.target.offsetHeight : 0)

        // 计算left和top
        l = x2 - x1
        t = y2 - y1
        // 设置不能超出左上角和右上角
        if (l < 0) {
          l = 0
        }
        if (t < 0) {
          t = 0
        }
        // 设置left和top的最大值 不能超过事件源本身
        var name = scales && targetClassName.indexOf('txun') == -1 ? (height - box.offsetHeight) / scales : height - box.offsetHeight
        if (t > name) {
          t = name
        }
        if (l > width - box.offsetWidth) {
          l = width - box.offsetWidth
        }
        visibleTop = document.documentElement.scrollTop || document.body.scrollTop
        if (targets) {
          box.style.left = l + 'px'
          box.style.top = t + 'px'
        } else {
          // 设置div的right和bottom
          box.style.right = (scales && targetClassName.indexOf('txun') == -1 ? width / scales - l / scales - box.offsetWidth : width - l - box.offsetWidth) + 'px'
          box.style.bottom = (scales && targetClassName.indexOf('txun') == -1 ? height - (t / scales + box.offsetHeight + visibleTop / scales) : height - t - box.offsetHeight) + 'px'
        }
      }
    }
    async function end(e) {
      if (pass) return
      if (transform && transform != 'none') {
        //记录拖动后的位置bottom
        window.$bottom = parseInt(box.style.bottom)
        window.$scrollTop = visibleTop / scales
      }
      flag = false
      if (!isMove) {
        if (_this.$route.name == 'Next') {
          if (targetClassName && targetClassName.indexOf('shop') > -1) {
            // if (!_this.$store.state.userInfo.userId) {
            //   _this.handleLoginAuth();
            //   return;
            // }
            layer.open({
              type: 2,
              title: '购物车',
              area: ['100%', '100%'],
              content: `${window.location.origin}/oqmid-pay-tool-web/shop/cart/list?pfId=${window.$pfId}&userCode=${_this.getQuery('localUserId') ? _this.getQuery('localUserId') : localStorage.getItem('wxud')}&userId=${_this.$store.state.userInfo.userId ? _this.$store.state.userInfo.userId : ''}`
            })
          } else if (targetClassName && targetClassName.indexOf('kefu') > -1) {
            if (!_this.$store.state.userInfo.userId) {
              _this.handleLoginAuth()
              return
            }
            var ite = $('.kefu.supFloat').parent()
            if (ite.hasClass('curr')) {
              ite.removeClass('curr')
              $('.communication ').remove()
            } else {
              ite.addClass('curr')
              var contentId = _this.$contentId
                ? _this.$contentId
                : _this.getQuery('id')
                  ? _this.getQuery('id')
                  : document.querySelector('#deliverable') && document.querySelector('#deliverable').contentWindow.document.querySelector("input[name='contentId']")
                    ? document.querySelector('#deliverable').contentWindow.document.querySelector("input[name='contentId']").getAttribute('value')
                    : ''
              var userId = _this.$store.state.userInfo.userId ? _this.$store.state.userInfo.userId : '',
                $createdId = ''
              if (userId) {
                //登录就请求
                let res = await _this.$http.get('/zciid-deliverable/api/abduction/getWzContentDataByAppId.json', {
                  appId: _this.$appId
                })
                if (res.state == 1) {
                  //通过appId获取contentId
                  $createdId = res.data.userId
                  //加入商圈
                  _this.$http.get('/zciid-deliverable/api/app/joinCircle', { id: res.data.contentId, userId: userId })
                } else {
                  // 没有数据读默认'zjznsc'平台数据
                  let req = await _this.$http.get('/zciid-deliverable/api/abduction/getWzContentDataByAppId.json', {
                    appId: 'zjznsc'
                  })
                  if (req.state == 1) {
                    //通过appId获取contentId
                    $createdId = req.data.userId
                    //加入商圈
                    _this.$http.get('/zciid-deliverable/api/app/joinCircle', { id: req.data.contentId, userId: userId })
                  }
                }
              }
              _this.openLayer('客服', _this.$store.state.baseURL + '/im/kf?appId=' + _this.getQuery('appId') + '&deliverableName=' + ($('.video-intro .tit span').length ? $('.video-intro .tit span')[0].innerText : '') + '&contentId=' + contentId + '&receiveId=' + $createdId)
            }
          }
        } else if (box.classList.contains('open')) {
          if ($('.open .hovers').is(':visible')) {
            $('.open .hovers').hide()
            $('.open .hoversTwo').hide()
          } else {
            $('.open .hovers').show()
          }
        }
      } else {
        isMove = false
      }
    }

    if (_this.IsMobile()) {
      box.addEventListener(
        'touchstart',
        function (e) {
          e.stopPropagation()
          if (e.target.tagName == 'LI' || e.target.tagName == 'A') return
          down(e)
        },
        false
      )
      box.addEventListener(
        'touchmove',
        function (e) {
          if (e.target.tagName != 'LI') {
            e.preventDefault()
          }
          move(e)
        },
        false
      )
      box.addEventListener(
        'touchend',
        function (e) {
          if (e.target.tagName == 'LI' || e.target.tagName == 'A') return
          end(e)
        },
        false
      )
    } else {
      box.addEventListener(
        'mousedown',
        function (e) {
          e.stopPropagation()
          if (e.target.tagName == 'LI' || e.target.tagName == 'A') return
          down(e)
        },
        false
      )
      document.addEventListener(
        'mousemove',
        function (e) {
          move(e)
        },
        false
      )
      box.addEventListener(
        'mouseup',
        function (e) {
          end(e)
        },
        false
      )
    }
  }
  // 筛选会员级别
  Vue.prototype.getMemberLevel = function (level) {
    var name = '',
      memberLevel = ''
    switch (level) {
      case '1':
        name = '普通会员价'
        memberLevel = 'ordinaryPrice'
        break
      case '2':
        name = '白银会员价'
        memberLevel = 'silverPrice'
        break
      case '3':
        name = '黄金会员价'
        memberLevel = 'goldprice'
        break
      case '4':
        name = '铂金会员价'
        memberLevel = 'platinumPrice'
        break
      case '5':
        name = '钻石会员价'
        memberLevel = 'diamondsPrice'
        break
      case '6':
        name = '黑金会员价'
        memberLevel = 'blackGoldprice'
        break
      default:
        name = ''
        break
    }
    return { name: name, memberLevel: memberLevel }
  }
  // 微信、钉钉分享
  Vue.prototype.weixinShare = async function (title, summary, picurl) {
    var _this = this;
    // 如果summray包含富文本，进行删选
    function extractTextFromRichText(htmlString) {
      // 创建一个临时的 DOM 元素
      let tempDiv = document.createElement('div')
      tempDiv.innerHTML = htmlString
      // 使用 innerText 属性获取纯文本内容
      let textContent = tempDiv.innerText
      return textContent
    }
    summary = extractTextFromRichText(summary)

    _this.getQuery('titleOne') ? (title = decodeURIComponent(_this.getQuery('titleOne'))) : ''
    _this.getQuery('summaryOne') ? (summary = decodeURIComponent(_this.getQuery('summaryOne'))) : ''
    _this.getQuery('picOne') ? (picurl = decodeURIComponent(_this.getQuery('picOne'))) : ''
    //请求微信配置参数接口（获取签名），由后台给接口给
    //看后台请求接口是get/post
    //qq二次分享
    var isQQ = u.match(/QQ\/([\d\.]+)/)
    if (isQQ) {
      mqq.data.setShareInfo({
        title: title, // 分享标题
        desc: summary, // 分享描述
        image_url: picurl ? picurl : window.location.origin + '/zjstatic/standard/images/about_logo.png', // 分享图片
        share_url: location.href // 分享链接
      })
    }

    var isWX = u.match(/MicroMessenger\/([\d\.]+)/)
    if (isWX) {
      _this.$http
        .post('/cme-sso-app/app/wechat/shareConfig', {
          url: location.href
        })
        .then((res) => {
          if (res.state == 1) {
            //微信加签
            var obj = {
              appId: res.data.appId,
              nonceStr: res.data.nonceStr,
              signature: res.data.signature,
              timestamp: res.data.timestamp,
              jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
            }
            // if(location.origin.indexOf('520emv') > -1 || location.origin.indexOf('kh.520ezn') > -1){
            if(location.origin.indexOf('kh.520ezn') > -1){
              //客户环境和中机集团环境
              var code = _this.getQuery('code'),storageCode=this.getCanExpireLocal('wxgetCode'),userId=_this.$store.state.userInfo.userId ? _this.$store.state.userInfo.userId : localStorage.getItem('noLoginSid');
              if(!storageCode){
                //没有获取过用户信息
                if(code){
                  //有code值
                  _this.$http.post('/cme-sso-app/app/wechat/getUserInfo.json', {
                    code: code ,
                    userId: userId
                  }).then(res => {
                    if(res.state == 1){
                      _this.$http.post('/cme-sso-app/api/pfacc/wxUserUD.json', {
                        accId: userId,
                        nickName:res.data.nickname,
                        photo:res.data.headimgurl
                      }).then((res)=>{
                        //请求过微信用户信息做标记
                        //三天过期时间
                        this.setCanExpireLocal('wxgetCode',code,3*24*3600*1000)
                      })
                    }else{
                      //引导用户前往授权页面
                      redirectToWechatAuth()
                    }
                  }).catch(err=> {
                    console.error('错误：', err);
                  })
                }else{
                  //没有code值引导用户前往授权页面
                  redirectToWechatAuth()
                }
              }
            }
            
            
            
            //分享数据，这段主要是为了在hash模式下分享出去的链接不被浏览器截取，保证完全把链接分享出去
            // var shareWxLink = encodeURIComponent(url);加密
            let shareData = {
              title: title, // 分享标题
              desc: summary,
              link: location.href,
              imgUrl: picurl ? picurl : window.location.origin + '/zjstatic/standard/images/about_logo.png' // 分享图标
            }
            //引用
            wexinShare(obj, shareData)
            function redirectToWechatAuth (){
              //没有code值跳转链接获取code
              var fromurl=location.href;
              var url='https://open.weixin.qq.com/connect/oauth2/authorize?appid='+ res.data.appId +'&redirect_uri='
                      + encodeURIComponent(fromurl)
                      +'&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
              location.href=url;
            }
          } else {
            console.log('获取sdk参数失败！')
          }
          
        })
    }
    
    function loadJS(url, callback) {
      var script = document.createElement('script')
      script.type = 'text/javascript'
      // 当脚本加载完成并执行后触发回调函数
      if (script.readyState) {
        // 仅限IE
        script.onreadystatechange = function () {
          if (script.readyState == 'loaded' || script.readyState == 'complete') {
            script.onreadystatechange = null
            callback()
          }
        }
      } else {
        // 其他浏览器
        script.onload = function () {
          callback()
        }
      }
      script.src = url
      document.body.appendChild(script)
    }
    var isDD = u.match(/DingTalk\/([\d\.]+)/)
    if (isDD) {
      loadJS('https://g.alicdn.com/dingding/open-develop/1.8.0/dingtalk.js', function () {
        dd.ready(() => {
          dd.biz.navigation.setRight({
            show: true, //控制按钮显示， true 显示， false 隐藏， 默认true
            control: true, //是否控制点击事件，true 控制，false 不控制， 默认false
            text: '...', //控制显示文本，空字符串表示显示默认文本
            onSuccess: function (result) {
              //如果control为true，则onSuccess将在发生按钮点击事件被回调
              dd.biz.util.share({
                type: 0, //分享类型，0:全部组件 默认； 1:只能分享到钉钉；2:不能分享，只有刷新按钮
                url: link,
                title: title,
                content: summary,
                image: picurl ? picurl : window.location.origin + '/zjstatic/standard/images/about_logo.png',
                onSuccess: () => {
                  console.log('分享成功')
                },
                onFail: (err) => {
                  console.log(`分享失败：${JSON.stringify(err)}`)
                }
              })
            },
            onFail: function (err) {}
          })
        })
      })
    }
  }
  Vue.prototype.$IM = {
    setIntervalWesocketPush: null,
    lockReconnect: false,
    lockConnected: false,
    token: null,
    config: {
      url: ''
    },
    baseData: function (cmdType, dataBody) {
      return JSON.stringify({
        packetLen: 16,
        version: '1',
        cmdType: cmdType,
        appType: 1,
        deviceType: 4,
        token: this.token,
        dataBody: dataBody
      })
    },
    /** 初始化token */
    setToken: function (token) {
      this.token = token
      return this
    },
    /** 初始化 */
    init: function (config) {
      this.config = config
      return this
    },
    /**
     * 自定义异常函数
     * @param {Object} errorMsg
     */
    error: function (errorMsg) {
      this.onerror(errorMsg)
    },
    /** 消息发送 */
    send: function (message) {
      if (this.socket) {
        this.socket.send(message)
        return true
      }
      return false
    },
    /** 关闭连接 */
    close: function () {
      if (this.socket != undefined && this.socket != null) {
        this.socket.close()
        this.socket = null // 清理
      }
      this.error('连接已经断开...')
    },
    /** 发送心跳 */
    heatBeat: function () {
      var $this = this
      $this.setIntervalWesocketPush = setInterval(() => {
        if ($this.lockConnected) {
          $this.send($this.baseData(68, { t: 0 }))
        }
      }, 5000)
    },
    cleanWS: function () {
      this.close()
      clearInterval(this.setIntervalWesocketPush)
      this.lockConnected = false
    },
    /** 链接回调函数 */
    onopen: function () {
      console.log('成功连接到服务器...')
      this.lockConnected = true
      if (this.connectCallBack) {
        this.connectCallBack()
      }
      this.heatBeat()
    },
    /** 关闭回调 */
    onclose: function () {
      console.log('客户端已断开连接')
      this.cleanWS()
      this.onerror('服务器断开重连')
    },
    /** 异常回调 */
    onerror: function (msg) {
      var $this = this
      if ($this.lockReconnect) return
      $this.lockReconnect = true
      //没连接上会一直重连，设置延迟避免请求过多
      setTimeout(function () {
        $this.cleanWS()
        $this.connect() // 重连
        $this.lockReconnect = false
      }, 3000)
    },
    /**
     * 消息回調
     * @param {Object} message
     */
    onmessage: function (msg) {
      console.log(msg + '----')
    },
    /** 连接webcocket */
    connect: function () {
      var $this = this
      var protocol = window.location.protocol == 'https:' ? 'wss:' : 'ws:'
      var configUrl = $this.config.url
      if (configUrl.indexOf('https://') > -1) {
        configUrl = configUrl.substring(7, configUrl.length)
      }
      if (configUrl.indexOf('http://') > -1) {
        configUrl = configUrl.substring(6, configUrl.length)
      }
      $this.host = protocol + configUrl + '/cme-im'
      window.WebSocket = window.WebSocket || window.MozWebSocket
      if (!window.WebSocket) {
        // 检测浏览器支持
        $this.error('Error: WebSocket is not supported .')
        return
      }
      $this.socket = new WebSocket($this.host) // 创建连接并注册响应函数
      $this.socket.onopen = function () {
        $this.onopen()
      }
      $this.socket.onmessage = function (event) {
        if (typeof event.data === 'string') {
          $this.onmessage(JSON.parse(event.data).dataBody)
        }
      }
      $this.socket.onclose = function () {
        $this.onclose()
      }
      $this.socket.onerror = function (errorMsg) {
        $this.onerror(errorMsg)
      }
      return this
    }
  }
  //IM调用
  Vue.prototype.IMInit = function (userId, userName, gid) {
    var timestamp = new Date().getTime()
    var uid = timestamp
    var _this = this
    _this.$IM.setToken(userId).init({ url: location.hostname })
    _this.$IM.connect()
    _this.$IM.connectCallBack = function () {
      _this.$IM.send(_this.$IM.baseData(68, { t: 0, uid: uid, gid: gid, userId: userId, userName: userName }))
    }
    _this.$IM.onmessage = function (msg) {
      onmessage(msg)
    }
    function onmessage(message) {
      if (!message) {
        return false
      }
      if (message.t == 3) {
        _this.$store.commit('sendBarrage', message)
      }
    }
  }
  // 统计右键点击次数
  Vue.prototype.addRecord = function (code, clickName) {
    var host = window.location.host
    var port = window.location.port
    if (host.indexOf(':') != -1) {
      port = ''
    }
    var url = 'http://' + host + port + '/zciid-deliverable/api/user/record/add'
    $.ajax({
      url: url,
      data: {
        appId: this.getQuery('appId'),
        userId: this.$store.state.userInfo.userId,
        clickCode: code,
        clickName: clickName,
        types: '1'
      },
      type: 'POST',
      success: function (result) {
        console.log('用户行为记录：' + result.message)
      }
    })
  }
  //
  ;(Vue.prototype.getSpecialUrl = function (ele, name, rid, titleName, userArr, wxud, noLoginSid) {
    var timestamp = new Date().getTime()
    var pfId = this.getQuery('pfId') ? this.getQuery('pfId') : window.$pfId
    var contentId = this.$contentId
      ? this.$contentId
      : this.getQuery('communicationId')
        ? this.getQuery('communicationId')
        : this.getQuery('id')
          ? this.getQuery('id')
          : document.querySelector('#deliverable').contentWindow.document.querySelector("input[name='contentId']")
            ? document.querySelector('#deliverable').contentWindow.document.querySelector("input[name='contentId']").getAttribute('value')
            : ''
    if (this.$store.state.userInfo && this.$store.state.userInfo.userId && this.$store.state.userInfo.userId == rid) {
      layer.msg('当前人为自己，无法通讯')
      return
    }
    this.$http
      .get('/meeting-tool-web/interface/meeting/sendAudio.json', {
        userId: this.$store.state.userInfo.userId ? this.$store.state.userInfo.userId : noLoginSid,
        userName: this.$store.state.userInfo.trueName ? this.$store.state.userInfo.trueName : wxud,
        receiveId: rid,
        type: ele,
        pfId: pfId,
        gid: timestamp,
        deliverableName: titleName ? titleName : '',
        kfctype: name == '语音通讯' ? 2 : 3,
        message: name,
        appId: this.$appId,
        contentId: contentId
      })
      .then((res) => {
        if (ele == '184') {
          this.open(res.data.url + '&contentId=' + contentId, '', name, '', '')
        } else {
          this.openLayer(name, this.$store.state.baseURL + '/im/' + (name == '语音通讯' ? 'audio' : 'video') + '?&pt=1&gid=' + timestamp + '&sid=' + (this.$store.state.userInfo.userId ? this.$store.state.userInfo.userId : noLoginSid) + '&rid=' + rid + '&contentId=' + contentId + '&wxud=' + wxud, titleName, userArr)
        }
      })
  }),
    // 新打开页面
    (Vue.prototype.open = function (url, type, name, third, area, contentId, ite, showTopOrNot) {
      var _this = this
      if (contentId && _this.$store.state.userInfo.userId) {
        //统计浏览量
        _this.$http.get('/zciid-deliverable/api/browse/addBrowse', {
          contentId: contentId,
          userId: _this.$store.state.userInfo.userId
        })
      }
      var map = {
        handleName: 'pushNewWebScene',
        params: {
          link: url,
          hiddenNavigation: '0',
          code: url.indexOf('app-h5-redirect') > -1 ? '0' : '1',
          bread: name,
          addParams: third ? '1' : '',
          transferPage: url.indexOf('app-h5-redirect') > -1 ? '1' : ''
        }
      }
      var connext = _this.postToApp(map, name, '', url)
      if (!connext) return
      var fontSize = localStorage.getItem('fontsize') && !third && u.match(/cmeplaza/i) == 'cmeplaza' && !u.match(/electron/i) ? '&fontSize=' + localStorage.getItem('fontsize') : ''
      if (u.indexOf('Electron') > -1) {
        if (name == '下载智能人') {
          window.location.href = url + fontSize
          return
        }
        var ipcRender = top.window.ipcRender ? top.window.ipcRender : top.window.require('electron').ipcRenderer
        ;(async () => {
          try {
            var data = { title: name, url: url }
            var array = ['onqid', 'oamid', 'odzid', 'zkzkid', 'aassid'].filter((tags) => url.indexOf(tags) > -1)
            var displayType = ''
            var environment = ''
            if (ite && ite.contentWzUrl) {
              environment = ite.contentWzUrl.split('.com')[0] + '.com'
            }
            if (!third && contentId) {
              //不是第三方跳转详情页获取详情页展示样式
              let resq = await _this.$http.get(environment + '/zciid-deliverable/api/abduction/getWzStandardTypeByContentId.json', { contentId: contentId })
              let res = await _this.$http.get(environment + '/zciid-deliverable/api/webapp/quote/get/display/type', {
                types: resq.data ? 'displayType-media' : 'displayType-general',
                wzAppId: ite.appId ? ite.appId : _this.getQuery('appId'),
                sixTypes: 'sign' + ite.sign
              })
              if (res.state == 1) {
                displayType = res.data
              }
            }
            if (!array.length || displayType == 'cmwz' || displayType == 'ftgt' || url.indexOf('brush') > -1 || showTopOrNot) {
              //带头部
              data.frame = true
            }
            ipcRender.send('openWindow', data)
          } catch (e) {
            console.log('不支持ipcRenderer')
          }
        })()
      } else {
        var ua = u.toLowerCase() //获取判断用的对象
        var iOSIs = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终
        if ((ua.match(/cmeplaza/i) == 'cmeplaza' && iOSIs) || type == '_self' || _this.IsMobile()) {
          window.location.href = url + fontSize
        } else {
          if (area) {
            $('#deliverable').attr('src', url)
          } else {
            window.open(url + fontSize, '_blank')
          }
        }
      }
    })
  // 价格格式化
  ;(Vue.prototype.formatPrice = function (agglomerateCount) {
    var num = agglomerateCount,
      endNum
    if (agglomerateCount.indexOf('/') > -1) {
      num = parseFloat(agglomerateCount)
    }
    endNum = num >= 10000 ? (num / 10000).toFixed(2) + '万' : num
    return agglomerateCount.indexOf('/') > -1 ? endNum + '/' + agglomerateCount.split('/')[1] : endNum
  }),
    //判断是否为价格
    (Vue.prototype.allPrice = function (type) {
      return ['basicPrice', 'cpyxprice', 'fwpzprice', 'ptxmprice', 'fwxmprice', 'jcxmprice', 'jqrxmprice', 'crhxmprice', 'gcxmprice', 'assetsPrice', 'periodicPrice', 'timesPrice', 'jqrccprice', 'jfpzxmprice', 'jfjsxmprice', 'tzxmprice', 'xmjcprice'].includes(type)
    }),
    //获取注册链接
    (Vue.prototype.getRegisterLink = function (query) {
      var link = 'https://520emv.com/cme-sso-app/register/to-register?ip=&regType=wz&inviteId=' + this.$store.state.creatUserId + '&inviteInfo=' + encodeURIComponent(JSON.stringify({ data: this.getQuery('appId') })) + '&inviteAppId=' + this.getQuery('appId') + '&invitePfId=' + window.$pfId + '&registerType=GXSJ'
      if (this.getQuery('uid')) {
        link =
          'https://520emv.com/cme-sso-app/register/to-register?ip=&regType=subordinate&inviteId=' + this.getQuery('uid') + '&inviteInfo=' + encodeURIComponent(JSON.stringify({ data: this.getQuery('appId') })) + '&inviteAppId=' + this.getQuery('sbAppId') + '&invitePfId=' + this.getQuery('sbPfId') + '&registerType=GXSJ'
      }
      if (query) {
        link += '&hideTop=false'
      }
      return link
    })
  //注册
  Vue.prototype.register = async function (share) {
    var link = this.getRegisterLink()
    if (share == 'share') {
      var _this = this,
        shareReg = sessionStorage.getItem('shareReg')
      if (!shareReg) {
        let resq = await _this.$http.get('/acnid-project-approve/custom/dwzUrl/transfor', { url: link })
        sessionStorage.setItem('shareReg', location.origin + '/acnid-project-approve/custom/dwzUrl?id=' + resq.data)
      }
      JLayer.openFrame({
        id: 'configData',
        type: 2,
        title: '分享注册',
        maxmin: true,
        area: ['100%', '100%'],
        url: location.origin + '/esbserver/api/apiapp/single-api-list?appType=1&appId=zjsqsanbao&shareReg=1&xxx=aassid'
      })
      JLayer.WebCategory = function (data) {
        _this.shareUniversal({ data: data }, encodeURIComponent(data.split('-').slice(1, -1).join('-')), '智能人注册', data.split('-').slice(1, -1).join('-'), '智能人注册', 'erweima')
      }
      return
    }
    if (share == 'scanshare') {
      var _this = this,
        shareReg = sessionStorage.getItem('shareReg')
      if (!shareReg) {
        let resq = await _this.$http.get('/acnid-project-approve/custom/dwzUrl/transfor', { url: link })
        sessionStorage.setItem('shareReg', location.origin + '/acnid-project-approve/custom/dwzUrl?id=' + resq.data)
      }
      layer.open({
        type: 2,
        title: '扫码注册',
        area: ['100%', '100%'],
        content: location.origin + '/zjstatic/standard/project/register_qh/codetoreg.html?url=' + encodeURIComponent(sessionStorage.getItem('shareReg'))
      })
      return
    }
    if (share == 'tabChangePage') {
      link = 'https://520emv.com/zjstatic/standard/project/register_qh/qiehuan.html?inviteId=' + this.$store.state.creatUserId + '&inviteInfo=' + encodeURIComponent(JSON.stringify({ data: this.getQuery('appId') })) + '&inviteAppId=' + this.getQuery('appId') + '&invitePfId=' + window.$pfId
    }
    if (share == 'ret') {
      return link
    }
    // if (this.fourPage()&&!this.getQuery('brush')) {
    //   var iframe = document.getElementById("deliverable");
    //   iframe.setAttribute("src", link);
    // } else {
    this.open(link, '_blank', '注册', '', '', '', '', true)
    // }
  }
  //授权登录
  ;(Vue.prototype.handleLoginAuth = function () {
    $.ajax({ url: '/cme-sso-app/logout', type: 'post' })
    if (top != self && top.location.pathname.indexOf('aassid') == -1) {
      top.newVue.handleLoginAuth()
    }
    var _toHref = `${window.location.origin}${window.location.pathname}${window.location.search}`
    this.$http.get('/acnid-project-approve/custom/dwzUrl/transfor', { url: encodeURIComponent(_toHref) }).then((res) => {
      let link = window.location.origin + '/acnid-project-approve/custom/dwzUrl?id=' + res.data
      window.location.href = `${document.location.origin}/cme-sso-app/login?servers=${encodeURIComponent(`${document.location.origin}/uoqid/sso/login?toUrl=${encodeURIComponent(link)}`)}`
    })
  }),
    // 退出登录
    (Vue.prototype.handleLogout = function () {
      this.$store.commit('setLoginState', false)
      // sessionStorage.removeItem('openId');
      // this.removeCookie('openId', ''，-1);
      this.$store.commit('setUserInfo', {})
      this.$store.commit('rightClickType', 531)
      this.$store.commit('setManageState', false)
      this.$store.commit('setRightMenu', { menu: [], append: [] })
      this.removeCookie('CMEPLAZAUSERID', '', -1)
      this.removeCookie('cmeAppToken', '', -1)
      this.$http.get('/zciid-deliverable/api/abduction/wzLogout')
      this.$store.state.rightMenu = []
      var _toHref = encodeURIComponent(`//${window.location.host}${window.location.pathname}${window.location.search}`)
      var _toUrl = `https://${window.location.host}/cme-sso-app/logout?toUrl=` + _toHref
      window.location.href = _toUrl
    })
  //获取节点样式
  ;(Vue.prototype.getElementStyle = function (obj, attr) {
    if (!obj) {
      return ''
    }
    if (obj.currentStyle) {
      return obj.currentStyle[attr]
    } else {
      return getComputedStyle(obj, false)[attr]
    }
  }),
    //计算右键位置
    (Vue.prototype.calculateLocation = function (ev, type) {
      var name = this.$store.state.pageFontSize,
        transform,
        cLocation = {}
      if (name) {
        transform = this.getElementStyle(document.getElementsByClassName(name)[0], 'transform')
      }
      if (this.getElementStyle(document.getElementById('app'), 'transform')) {
        transform = this.getElementStyle(document.getElementById('app'), 'transform')
      }
      if (transform && transform != 'none') {
        var scale = transform.split(',')[3]
        // 160右键最大宽
        if ((ev.pageX ? ev.pageX : ev.targetTouches[0].pageX) + 160 * scale > window.innerWidth) {
          cLocation.left = (window.innerWidth - 160 * scale) / scale
        } else {
          cLocation.left = (ev.pageX ? ev.pageX : ev.targetTouches[0].pageX) / scale
        }
        cLocation.top = ((ev.pageY ? ev.pageY : ev.targetTouches[0].pageY) - (type ? type : 0)) / scale
      } else {
        if ((ev.pageX ? ev.pageX : ev.targetTouches[0].pageX) + 160 > window.innerWidth) {
          cLocation.left = window.innerWidth - 160
        } else {
          cLocation.left = ev.pageX ? ev.pageX : ev.targetTouches[0].pageX
        }
        cLocation.top = (ev.pageY ? ev.pageY : ev.targetTouches[0].pageY) - (type ? type : 0)
      }
      return cLocation
    }),
    // 右键办理
    (Vue.prototype.handle = function () {
      var sceneGroupId = this.getQuery('sceneGroupId'),
        workId = this.getQuery('workId'),
        sceneId = this.getQuery('sceneId')
      this.accOrChePost(window.location.origin + '/acnid-project-approve/acceptcheck/accept/list', {
        sceneGroupId: sceneGroupId,
        workId: workId, //工作节点id（必填项）
        sceneId: sceneId, //场景id（必填项）
        acceptanceUrl: acceptanceUrl, //办理url（必填项）
        previewUrl: previewUrl //预览url（必填项）
      })
      return false
    }),
    // 右键验收
    (Vue.prototype.checkAndAccept = function () {
      var sceneGroupId = this.getQuery('sceneGroupId'),
        workId = this.getQuery('workId'),
        sceneId = this.getQuery('sceneId')
      this.accOrChePost(window.location.origin + '/acnid-project-approve/acceptcheck/check/list', {
        sceneGroupId: sceneGroupId,
        workId: workId, //工作节点id（必填项）
        sceneId: sceneId, //场景id（必填项）
        acceptanceUrl: acceptanceUrl, //办理url（必填项）
        previewUrl: previewUrl //预览url（必填项）
      })
      return false
    }),
    //办理验收模拟表单提交
    (Vue.prototype.accOrChePost = function (url, params) {
      // 创建form元素
      var temp_form = document.createElement('form')
      // 设置form属性
      temp_form.action = url
      temp_form.target = '_self'
      temp_form.method = 'post'
      temp_form.style.display = 'none'
      // 处理需要传递的参数
      for (var x in params) {
        var opt = document.createElement('textarea')
        opt.name = x
        opt.value = params[x]
        temp_form.appendChild(opt)
      }
      document.body.appendChild(temp_form)
      // 提交表单
      temp_form.submit()
    }),
    // 外展、业务、邮箱、设备页面
    (Vue.prototype.specialPage = function (url, params) {
      var link = window.location.href.split('?')[0],
        array = ['onqid', 'oamid', 'odzid', 'zkzkid'],
        flag = false
      if (array.filter((tags) => link.indexOf(tags) > -1).length) {
        flag = true
      }
      return flag
    }),
    //除详情页外的四种页面
    (Vue.prototype.fourPage = function (url, params) {
      if (this.specialPage && !(window.location.href.indexOf('blockId') > -1 && window.location.search && !this.getQuery('pfId'))) {
        return true
      } else {
        return false
      }
    }),
    //链接在客户端工作台展示
    (Vue.prototype.iframeOpen = function (area1, area2, link, menuName) {
      var iframe = document.getElementById('testiframe'),
        iframe1
      if (this.IsMobile() || !iframe) {
        layer.open({
          type: 2,
          title: menuName,
          area: ['100%', '100%'],
          content: link
        })
        return
      }
      if (!link) {
        link = area2
        area1 = 'MainFrame'
        area2 = 'toolsFrame'
      }

      if (iframe) {
        iframe1 = iframe.contentWindow.document.getElementById(area1)
        if (iframe1) {
          iframe1.scrollIntoView({ behavior: 'smooth' })
          iframe1.contentWindow.document.getElementById(area2).setAttribute('src', link)
        }
      }
    }),
    //ios断网状态修改图片、视频链接
    (Vue.prototype.changeUrl = function (data) {
      var ua = u.toLowerCase(),
        val = data.replace(/^http:\/\//i, 'https://')
      // if (ua.match(/cmeplaza/i) == "cmeplaza" && !ua.match(/electron/i) && val){
      //     if (window.location.origin.indexOf('520ezj') > -1) {
      //         val = 'http://localhost:3002' + val.split('.com')[1];
      //     } else if (window.location.origin.indexOf('cmeplaza') == -1) {
      //         val = 'http://localhost:3001' + val.split('.com')[1];
      //     }
      // }
      return val
    }),
    //路由跳转
    (Vue.prototype.routerJump = function (mode, path, obj, name) {
      var _this = this
      //统计浏览量
      if (_this.$store.state.userInfo.userId) {
        _this.$http.get('/zciid-deliverable/api/browse/addBrowse', {
          contentId: obj.contentId,
          userId: _this.$store.state.userInfo.userId
        })
      }

      let text = _this.$router.resolve({ path: path, query: obj })
      let url = location.origin + text.href
      var map = {
        handleName: 'pushNewWebScene',
        params: {
          link: url,
          hiddenNavigation: '0',
          code: '1',
          bread: name
        }
      }
      var connext = _this.postToApp(map, name, '', url)
      if (!connext) return
      switch (mode) {
        case 'push': {
          _this.$router.push({ path: path, query: obj })
          break
        }
        case 'replace': {
          _this.$router.replace({ path: path, query: obj })
          break
        }
      }
    })
  //右键
  Vue.prototype.liNewHoverPublic = function (item, that) {
    if (that.$store.state.userInfo.userId) {
      that.addRecord(item.childmenu, item.menuName)
    }
    var aname = ['直接发布', '选择发布', '一键发布', '更新发布', '同步发布', '一键更新', '一键删除', '永久推送', '临时推送']
    if (that.$route.name == 'Next' && aname.includes(item.menuName)) {
      item.redirectUrl += '&openIssueType=hideTop'
    }

    if (item.menuName == '抓取') {
      startGrab()
      that.rightShow = false
      return
    }
    var type = window.$changeFlowBlock
    if (type == 'flow') {
      type = 'flow-floorStyle'
    } else {
      type = 'block-floorStyle'
    }
    var _url = ''
    if (item.targetType == 'none') {
      return false
    }
    //下载
    if (item.childmenu.indexOf('download') > -1) {
      that.downLoad('', window.outerName, window.$contentWzUrl)
      that.rightShow = false
      return
    }
    //打印
    if (item.childmenu.indexOf('print') > -1) {
      that.toPrint()
      that.rightShow = false
      return
    }
    var pinglunContent = window.$otherDatas,
      ite = window.$rightLeft.center.item,
      url = ''
    if (pinglunContent && that.$store.state.userInfo.userId && ite) {
      url =
        pinglunContent.contentId +
        '&creatUserId=' +
        pinglunContent.userId +
        '&creatUserName=' +
        pinglunContent.userName +
        '&userId=' +
        that.$store.state.userInfo.userId +
        '&userName=' +
        that.$store.state.userInfo.trueName +
        '&photo=' +
        (that.$store.state.userInfo.photo ? that.$store.state.baseURL + `/cme-sso-app/showimg/${JSON.parse(that.$store.state.userInfo.photo)[0].id}` : '') +
        '&transmitUrl=' +
        encodeURIComponent(window.location.origin + '/uoqid/odzid?appId=' + (ite.appId ? ite.appId : that.getQuery('appId')) + '&blockId=' + ite.nodeId + '&contentId=' + ite.contentId + '&floorflowId=' + window.$floorflowId.id + '&dataType=' + window.$dataType) +
        '&stanardByAppNameData=' +
        pinglunContent.stanardByAppNameData +
        '&stanardByMainFigureData=' +
        pinglunContent.stanardByMainFigureData +
        '&stanardByBasicPriceData=' +
        pinglunContent.stanardByBasicPriceData +
        '&stanardByVideoShowData=' +
        pinglunContent.stanardByVideoShowData +
        '&pfId=' +
        window.$pfId
    }
    //转发到商圈
    if (item.menuName.indexOf('转发到商圈') > -1) {
      var startUrl = that.$store.state.baseURL + '/zciid-deliverable/interface/deliverables/transmit/circle/list?contentId='
      that.iframeOpen('MainFrame', 'toolsFrame', startUrl + url, item.menuName)
      that.rightShow = false
      return
    }
    //转发给好友
    if (item.menuName.indexOf('转发给好友') > -1) {
      var startUrl = that.$store.state.baseURL + '/zciid-deliverable/interface/deliverables/transmit/user/list?contentId='
      url = pinglunContent.contentId + '&creatUserId=' + pinglunContent.userId + '&creatUserName=' + pinglunContent.userName + '&userId=' + that.$store.state.userInfo.userId + '&userName=' + that.$store.state.userInfo.trueName
      that.iframeOpen('MainFrame', 'toolsFrame', startUrl + url, item.menuName)
      that.rightShow = false
      return
    }
    if (item.redirectUrl) {
      _url = that.replaceDataByWell(item.redirectUrl, item, type, item)
    }
    var left = (window.innerWidth - 900) / 2
    var wH = window.innerHeight / 2 - 100
    let promoteFirefoxWindowName
    //------------------------------------
    // if (item.targetType == "opeFrame") {
    if (item.childmenu == 'floorLeftCircleChoose') {
      //楼层左侧商圈选择
      if (!that.canAddCircle) {
        that.$notify({
          position: 'top-right',
          title: '提示',
          message: '您左侧已勾选流程数据，请先取消再进行此操作！',
          type: 'warning',
          offset: wH
        })
        return false
      }
    }
    if (item.childmenu == 'detailLeftCircleChoose') {
      //详情左侧商圈选择
      _url = item.redirectUrl.split('?')[0]
      let detailfloorListParams = ''
      if (window.$rightLeft && window.$rightLeft.center.contentId) {
        detailfloorListParams = window.$rightLeft.center.contentId + '&flowOrDetail=detail'
      } else {
        if (!detailfloorListParams) {
          detailfloorListParams = window.$blockId + '&flowOrDetail=block'
        }
      }

      _url = item.redirectUrl + detailfloorListParams
    }

    if (item.childmenu == 'detailFloorArchConfig') {
      if (!window.$blockId) {
        that.$notify({
          position: 'top-right',
          title: '提示',
          message: '请在流程块上进行详情场景架构的勾选!',
          type: 'warning',
          offset: wH
        })
        return
      }
    }
    if (item.childmenu == 'platDeliveryConfig') {
      var nodeId = window.$nodeId
      if (!nodeId) {
        that.$notify({
          position: 'top-right',
          title: '提示',
          message: '该节点不是流程块，无工作标签！',
          type: 'warning',
          offset: wH
        })
        return
      }
    }
    if (item.childmenu == 'jfwsxpz') {
      var nodeId = window.$nodeId
      if (!nodeId) {
        that.$notify({
          position: 'top-right',
          title: '提示',
          message: '该节点不是流程块，无工作标签！',
          type: 'warning',
          offset: wH
        })
        return
      }
    }
    if (item.menuName == '更换中间块展示方式') {
      _url = _url + '&flowOrBlockType=' + type
    }

    //判断zjjt客户端环境 在工作台打开弹窗
    if (parent.parent.location.pathname.indexOf('zjjt') > -1) {
      parent.open(_url, 'mainFrame')
    } else if (item.childmenu != 'openFloorLive' && item.childmenu != 'setTopDefaultProcess' && item.childmenu != 'calTopDefaultProcess' && item.childmenu != 'addToCart' && item.childmenu != 'addToCart2') {
      if (item.childmenu == 'wzjfwcz3hUE38m0A') {
        return
      }
      var herfUrls = 'http://' + window.location.host
      // var herfUrls ="http://"+ '520emv.com';
      var _this = that
      switch (item.targetType) {
        case 'opeFrame':
        case 'diy-workbench':
          //链接在客户端自定义工作台展示
          _this.iframeOpen('MainFrame', 'toolsFrame', _url, item.menuName)
          break
        case 'diy-scene':
          var iframe = document.getElementById('testiframe'),
            iframe1
          if (iframe) {
            iframe1 = iframe.contentWindow.document.getElementById('MainFrame1')
            if (iframe1) {
              iframe1.scrollIntoView({ behavior: 'smooth' })
              iframe1.contentWindow.document.getElementById('toolsFrame').setAttribute('src', _url)
              iframe1.contentWindow.document.getElementById('toolsFrameBox').css('width', '100%')
              iframe1.contentWindow.document.getElementById('toolsFrameBox').css('height', '100%')
              iframe1.contentWindow.document.getElementById('toolsFrameBox').css('top', '0px')
              iframe1.contentWindow.document.getElementById('toolsFrameBox').css('left', '0px')
              iframe1.contentWindow.document.getElementById('toolsFrameBox').css('z-index', '1')
            }
          }
          break
        case 'workbench':
          //链接在客户端工作台展示
          _this.iframeOpen('MainFrame', 'workFrame', _url, item.menuName)
          break
        case 'movelink': //动态连接
          var appId = _this.$appId
          $.ajax({
            type: 'get',
            url: herfUrls + '/zciid-deliverable/showPlatformStyle/flow/api/getAPPUrlByAppId?appId=' + appId,
            success: function (response) {
              if (response.state == 1) {
                //链接在客户端自定义工作台展示
                _this.iframeOpen('MainFrame', 'toolsFrame', response.data, item.menuName)
              }
            }
          })
          break
        case 'newblank':
          //该链接 带有三宝壳新打开页面处理
          if (item.childmenu == 'hygl-hyglpt') {
            _this.iframeOpen('MainFrame', 'toolsFrame', _url, item.menuName)
          } else if (item.childmenu == 'jfwtj-ydzmtj') {
            _this.iframeOpen('MainFrame', 'toolsFrame', _url, item.menuName)
          } else if (item.childmenu == 'ylwz') {
            _this.iframeOpen('MainFrame', 'toolsFrame', _url, item.menuName)
          } else if (item.childmenu.indexOf('diy-workbench') != -1) {
            _this.iframeOpen('MainFrame', 'toolsFrame', _url, item.menuName)
          } else {
            // location.href = _url;
            _this.open(_url, '_self')
          }
          break
        case 'alertInfo':
          layer.alert(_url)
          break
        case 'none':
          break
        default:
          break
      }
    }

    // }
    //----------------------------------------------
    if (item.childmenu == 'scgid-ZNYJTYPT-guru-block-84185742417' || item.childmenu == 'scgid-ZNYJTYPT-guru-block-75912186589') {
      //清除勾选主导航
      this.clearMainNavChecked('main-nav')
    }

    if (item.childmenu == 'scgid-ZNYJTYPT-guru-block-32156164943' || item.childmenu == 'scgid-ZNYJTYPT-guru-block-94250234300') {
      //清除勾选副导航优先级
      that.clearMainNavChecked('sub-nav-priority')
    }

    //加入购物车
    that.addToCart(item)
    if (item.targetType == 'operateFunc') {
      //左移右移
      // that.moveLeftOrRight(item);
      //取消设置默认流程
      that.setOrCancelFlow(item)
      //轮播配置取消
      that.setOrCancelSwiper(item)
      //预览外展
      that.previewTargetSite(item, wH)
      //右键标签展示
      that.dataRightMenuShow(item)
      //开启直播
      // that.initLiveRoom(item);

      if (item && item.childmenu == 'openFloorLive') {
        var urls = that.$store.state.baseURL + `/meeting-tool-web/blivebroadcast/config?createId=${that.$store.state.userInfo.userId}`
        //链接在客户端自定义工作台展示
        let iframe = document.getElementById('testiframe'),
          iframe1
        if (iframe) {
          iframe1 = iframe.contentWindow.document.getElementById('MainFrame')
          if (iframe1) {
            iframe1.scrollIntoView({ behavior: 'smooth' })
            iframe1.contentWindow.document.getElementById('toolsFrame').setAttribute('src', urls)
          }
        }
      }
    }
    if (window.$chooseToCart) return
    that.rightShow = false
  }
  //配置链接数据替换方法
  Vue.prototype.replaceDataByWell = function (url, menu, type, item) {
    let contentId = '',
      communicationId = ''
    if (window.$rightLeft) {
      contentId = window.$rightLeft.center.contentId ? window.$rightLeft.center.contentId : ''
      communicationId = window.$rightLeft.center && window.$rightLeft.center.item && window.$rightLeft.center.item.communicationId ? window.$rightLeft.center.item.communicationId : ''
    }
    let environment = document.location.pathname.split('/')[1] ? document.location.pathname.split('/')[1] : 'uoqid'
    let appId = this.$appId
    let appName = window.$appName ? window.$appName : ''
    let blockId = window.$blockId ? window.$blockId : ''
    let dataType = window.$dataType ? window.$dataType : ''
    let outerName = window.outerName ? window.outerName : ''
    let isYyz = window.$isYyz ? window.$isYyz : 0
    let releaseId = window.$releaseId ? window.$releaseId : ''
    let isBlock = window.$isBlock ? window.$isBlock : ''
    let userId = this.$store.state.userInfo.userId ? this.$store.state.userInfo.userId : localStorage.getItem('noLoginSid')
    let userName = this.$store.state.userInfo.trueName ? this.$store.state.userInfo.trueName : localStorage.getItem('wxud')
    //楼层id
    let floorflowId = window.$floorflowId && window.$floorflowId.flowEnName ? window.$floorflowId.flowEnName : ''
    let flowId = ''
    if (menu.childmenu == 'changeBlockType' || (menu.childmenu == 'zaicizhincp-index-20220128094406-UWHlYj8G' && item.menuName == '账号登录注册') || menu.menuName.indexOf('标签配置') > -1 || menu.menuName.indexOf('资产配置') > -1) {
      flowId = window.$floorId ? window.$floorId : ''
    } else {
      flowId = window.$floorflowId && window.$floorflowId.id ? window.$floorflowId.id : ''
    }
    let nodeId = window.$nodeId ? window.$nodeId : ''
    let pfId = window.$pfId ? window.$pfId : ''
    let sceneId = window.$sceneId ? window.$sceneId : ''
    let pageType = this.$route.query.diyPageFlowId ? 'diy-page' : 'index'
    let diyPageFlowCode = this.$route.query.code ? this.$route.query.code : ''
    let contentWzUrlIsYyz
    let transmitUrl = ''
    let dsfBlockId = window.$search && Object.keys(window.$search).length ? window.$search.item.id : window.$defaultBlockId ? window.$defaultBlockId : ''
    let outBlockId = window.$search && Object.keys(window.$search).length ? window.$search.item.id : ''
    let outBlockName = window.$search && Object.keys(window.$search).length ? window.$search.item.name : ''
    let stanardByAppNameData = window.$item && Object.keys(window.$item).length && window.$item.tags.length ? window.$item.tags[0].standardData : ''
    let stanardByMainFigureData = encodeURIComponent(window.$item && Object.keys(window.$item).length && window.$item.pictures.length ? window.$item.pictures[0] : '')
    if (window.$contentWzUrl) {
      var array = window.$contentWzUrl.split('=')
      if (array.length > 2 && window.$contentWzUrl.indexOf('id=') > -1) {
        array[array.length - 1] = isYyz
        contentWzUrlIsYyz = array.join('=')
        transmitUrl = encodeURIComponent(contentWzUrlIsYyz)
      } else {
        transmitUrl = encodeURIComponent(window.$contentWzUrl)
      }
    } else {
      transmitUrl = encodeURIComponent(window.location.href.split('?')[0] + '/odzid?appId=' + appId + '&blockId=' + nodeId + '&contentId=' + contentId + '&floorflowId=' + floorflowId + '&dataType=' + dataType + '&isYyz=' + isYyz)
    }
    let publishUrl = encodeURIComponent(window.location.href.split('?')[0] + '/odzid?id=' + releaseId)
    return url.replace(
      /(#appId)|(#appName)|(#outBlockId)|(#outBlockName)|(#contentName)|(#flowId)|(#blockId)|(#isBlock)|(#publishUrl)|(#transmitUrl)|(#isYyz)|(#floorflowId)|(#floorEnName)|(#contentId)|(#communicationId)|(#userId)|(#userName)|(#environment)|(#dataType)|(#outerName)|(#nodeId)|(#diyPageFlowCode)|(#pfId)|(#name)|(#logo)|(#url)|(#sceneId)|(#dsfBlockId)|(#pageType)|(http:\/\/cms.cmeplaza)/g,
      (match) => {
        if (match == '#transmitUrl' || match == '#url') {
          if (menu.menuName.indexOf('粉丝分享') > -1) {
            transmitUrl += encodeURIComponent('&showMore=false')
          }
          return transmitUrl
        }
        if (match == '#name') {
          return stanardByAppNameData
        }
        if (match == '#logo') {
          return stanardByMainFigureData
        }
        if (match == '#publishUrl') {
          return publishUrl
        }
        if (match == '#isYyz') {
          return isYyz
        }
        if (match == '#dsfBlockId') {
          return dsfBlockId
        }
        if (match == '#isYyz') {
          return isYyz
        }
        if (match == '#isBlock') {
          return isBlock
        }
        if (match == '#userId') {
          return userId
        }
        if (match == '#userName') {
          return userName
        }
        if (match == '#floorflowId' || match == '#floorEnName') {
          return floorflowId
        }
        if (match == '#outerName' || match == '#contentName') {
          return outerName
        }
        if (match == '#environment') {
          return environment
        }
        if (match == '#dataType') {
          return parseInt(dataType)
        }
        if (match == '#appId') {
          return appId
        }
        if (match == '#appName') {
          return appName
        }
        if (match == '#outBlockId') {
          return outBlockId
        }
        if (match == '#outBlockName') {
          return outBlockName
        }
        if (match == '#flowId') {
          if (menu.childmenu == 'changeBlockType') {
            if (type == 'flow-floorStyle') {
              return flowId
            } else {
              return blockId
            }
          } else {
            return flowId
          }
        }
        if (match == '#diyPageFlowCode') {
          return diyPageFlowCode
        }
        if (match == '#blockId') {
          return blockId
        }
        if (match == '#contentId') {
          return contentId
        }
        if (match == '#communicationId') {
          return communicationId
        }
        if (match == '#nodeId') {
          return nodeId
        }
        if (match == '#pfId') {
          return pfId
        }
        if (match == '#sceneId') {
          return sceneId
        }
        if (match == '#pageType') {
          return pageType
        }
        if (match == 'http://cms.cmeplaza') {
          return 'https://cms.cmeplaza'
        }
      }
    )
  }
  //匹配相同数据
  Vue.prototype.matching = function (type) {
    var index = 0
    if (type.length) {
      type.forEach((ele, ind) => {
        ele.forEach((item) => {
          if (item.contentId == this.$contentId) {
            index = ind
          }
        })
      })
    }
    return index
  }
  //打开视频弹窗
  Vue.prototype.openVideo = function (data, title) {
    var id = data.split('.mp4')[0].split('/').pop()
    layer.open({
      id: 'transpond',
      type: 2,
      title: title,
      fixed: true,
      maxmin: true,
      area: ['100%', '100%'],
      content: location.origin + '/zjstatic/standard/video/odzid.html?id=' + id + '&title=' + title
    })
  }
  //匹配项目基础价\产品营销价展示，有基础价产品价不显示，没有基础价基础价不显示
  Vue.prototype.filterJCPrice = function (data) {
    //判断有没有基础价
    var length = data.filter((tag) => tag.standardEnName == 'xmjcprice' && (tag.standardData || tag.data)).length
    if (length) {
      return data.filter((tag) => tag.standardEnName != 'cpyxprice')
    } else {
      return data.filter((tag) => tag.standardEnName != 'xmjcprice')
    }
  }
}

export default base



// WEBPACK FOOTER //
// ./src/base.js